<div class="accordian fusion-accordian">
  <div class="panel-group" id="accordion-1423-1" role="tablist">
    <div
      class="fusion-panel panel-default fusion-toggle-no-divider"
      role="tabpanel"
    >
      <div class="panel-heading">
        <style type="text/css">
          @media only screen and (max-width: 800px) {
            .ng-go-back-link {
              margin-bottom: 0px !important;
            }
            div.ng-go-back-link p {
              text-align: left !important;
            }
            .ng-space {
              margin-top: 40px !important;
            }
          }
        </style>
        <div class="ng-go-back-link" style="margin-bottom: -60px">
          <p style="text-align: right; cursor: pointer">
            <a (click)="goToTenders()" target="_self"
              ><strong>&lt; Torna alle Mie Gare</strong></a
            >
          </p>
        </div>
        <div style="width: min-content">
          <h4 class="panel-title toggle">
            <a
              aria-expanded="false"
              aria-selected="false"
              aria-controls="97d3a81aaa944fa91"
              role="tab"
              data-toggle="collapse"
              data-parent="#accordion-1423-1"
              data-target="#97d3a81aaa944fa91"
              href="#97d3a81aaa944fa91"
              ><span class="fusion-toggle-icon-wrapper" aria-hidden="true"
                ><i class="fa-fusion-box"></i></span
              ><span class="fusion-toggle-heading">LEGENDA</span></a
            >
          </h4>
        </div>

        <div id="97d3a81aaa944fa91" class="panel-collapse collapse">
          <style>
            ol.letter,
            ol.number {
              counter-reset: list;
              margin: 10px 0 10px 0;
            }
            ol.letter > li,
            ol.number > li {
              list-style: none;
              font-size: 15px;
              color: #333333;
              font-weight: 400;
              margin-top: 10px;
            }
            ol.letter > li:before {
              counter-increment: list;
              content: counter(list, lower-alpha) ") ";
            }

            ol.number > li:before {
              content: counter(list) ") ";
              counter-increment: list;
            }
            span.column-name {
              border: 1px solid #333333;
              margin-right: 5px;
              padding: 0 2px;
              font-size: 14px;
            }
          </style>
          <div class="panel-body toggle-content fusion-clearfix">
            <h5>
              Tutti i dati obbligatori sono contraddistinti da un asterisco
              &#8220;<strong>*</strong>&#8220;.
            </h5>
            <div
              class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 10px"
            ></div>
            <h5>
              <span class="legendTitle">CONDIVISIONE GARA</span> Mediante il
              link <span class="legendLabel">Condividi</span> il Proponente può
              permettere la visualizzazione della gara in sola lettura ad un
              terzo soggetto (Collaboratore, Committente, ecc.), inserendo
              nell’apposito form la email (<i
                >previa registrazione e Login in Skimming</i
              >) e cliccando su <span class="legendLabel">INVIA INVITO</span>.
            </h5>
            <div
              class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 10px"
            ></div>
            <div *ngIf="loadedTender.tenderType === 'PRIVATE'">
              <h5>
                <span class="legendTitle">CERCA UN PROGETTISTA</span> Mediante
                il link <span class="legendLabel">Cerca un progettista</span> è
                possibile ricercare un professionista (che si è registrato su
                Skimming) con la sede operativa nel raggio di 50 Km dal
                cantiere. Verrà proposta una lista di nominativi con ordine
                decrescente a partire dal più vicino. A scelta effettuata verrà
                inviata una notifica al professionista con le informazioni di
                contatto.
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
            </div>
            <h5>
              <span class="legendTitle">TITOLI ABILITATIVI</span> In questa
              sezione è possibile mettere il flag su
              <span class="legendLabel">Già Ottenuti</span> per evidenziare la
              certezza delle tempistiche e l’immediata disponibilità del
              cantiere, oppure, va messo il flag su
              <span class="legendLabel">In fase di ottenimento</span> quando si
              è in attesa del rilascio delle autorizzazioni.
            </h5>
            <div
              class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 10px"
            ></div>
            <h5>
              <span class="legendTitle">SUBAPPALTO</span> In questa sezione è
              possibile mettere il flag su
              <span class="legendLabel"
                >Gara condotta a finalità di Subappalto</span
              >
              qualora il Proponente sia un appaltatore (General Contractor,
              Impresa appaltatrice) in cerca di un’impresa esecutrice, oppure,
              va messo il flag su
              <span class="legendLabel">Non è un subappalto</span> quando il
              Proponente è il professionista che assiste il Committente oppure
              il Committente stesso.
            </h5>
            <div
              class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 10px"
            ></div>
            <div *ngIf="loadedTender.tenderType !== 'PRIVATE'">
              <h5>
                <span class="legendTitle">MIGLIORE OFFERTA</span> In questa
                sezione è possibile mettere il flag su
                <span class="legendLabel"
                  >Mostra la migliore offerta ricevuta</span
                >
                qualora, valutando lo stimolo che può dare nella ricerca del
                prezzo più equo e competitivo, il Proponente decida che sia
                visibile pubblicamente il miglior prezzo fatto per la
                realizzazione dell’opera, oppure, è possibile mettere il flag su
                <span class="legendLabel">Informazione riservata</span> qualora
                il Proponente scelga di non dare questa informazione, oppure,
                voglia dare l’informazione nelle fasi successive, sconto o
                ulteriore revisione. <br />L’uso dell’opzione
                <span class="legendLabel"
                  >Mostra la migliore offerta ricevuta</span
                >
                non deve essere interpretato come l’avvio di una sorta di ASTA
                Pubblica al Ribasso, ma va bensì interpretato come una ricerca
                equilibrata e ragionevole del prezzo più giusto ed equo e quale
                stimolo ad una sana e trasparente competizione.
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
            </div>
            <div *ngIf="loadedTender.tenderType === 'PRIVATE'">
              <h5>
                <span class="legendTitle">MIGLIORE OFFERTA</span> In questa
                sezione non è possibile mettere il flag su
                <span class="legendLabel"
                  >Mostra la migliore offerta ricevuta</span
                >.
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
            </div>
            <div *ngIf="loadedTender.tenderType !== 'PRIVATE'">
              <h5>
                <span class="legendTitle">CARICA FOTO</span> In questa sezione
                il Proponente può caricare file di foto ( max 15 Mb ) valutando
                se e quali rendere pubbliche mettendo il flag su
                <span class="legendLabel">Visibile pubblicamente</span>.
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
              <h5>
                <span class="legendTitle">CARICA DISEGNI</span> In questa
                sezione il Proponente può caricare file di autocad ( max 100 Mb)
                valutando se e quali disegni rendere pubblici mettendo il flag
                su <span class="legendLabel">Visibile pubblicamente</span>.
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
              <h5>
                <span class="legendTitle">CARICA ALTRO</span> In questa sezione
                il Proponente può caricare i file degli allegati ( max 50 Mb)
                che ritiene necessari per l’espletamento della gara d’appalto (
                autorizzazioni, relazioni, descrizioni delle opere, piani di
                sicurezza, fac simile di contratto d’appalto,ecc.), valutando se
                e quali rendere pubblici mettendo il flag su
                <span class="legendLabel">Visibile pubblicamente</span>.
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
            </div>
            <div *ngIf="loadedTender.tenderType === 'PRIVATE'">
              <h5>
                <span class="legendTitle">CARICA FOTO</span> In questa versione
                (Gara Committenti) il Proponente può caricare file di foto (max
                5 file da suddividere con CARICA DISEGNI e CARICA ALTRO)
                valutando se e quali rendere pubbliche mettendo il flag su
                <span class="legendLabel">Visibile pubblicamente</span>.
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
              <h5>
                <span class="legendTitle">CARICA DISEGNI</span> In questa
                versione (Gara Committenti) il Proponente può caricare file di
                autocad (max 5 file da suddividere con CARICA FOTO e CARICA
                ALTRO) valutando se e quali disegni rendere pubblici mettendo il
                flag su <span class="legendLabel">Visibile pubblicamente</span>.
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
              <h5>
                <span class="legendTitle">CARICA ALTRO</span> In questa versione
                (Gara Committenti) il Proponente può caricare file degli
                allegati (max 5 file da suddividere con CARICA FOTO e CARICA
                DISEGNI) che ritiene necessari per l’espletamento della gara
                d’appalto ( autorizzazioni, relazioni, descrizioni delle opere,
                piani di sicurezza, fac simile di contratto d’appalto,ecc.),
                valutando se e quali rendere pubblici mettendo il flag su
                <span class="legendLabel">Visibile pubblicamente</span>.
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
              <h5>
                <span class="legendTitle">AGGIUNGI DETTAGLIO</span> La voce
                aggiungi dettaglio esplode un form con le voci
                <u>Breve Descrizione</u>, <u>Unità di Misura</u> e
                <u>Quantità</u> che debitamente compilati andranno a costituire
                il computo metrico ad uso dell’Impresa per la redazione della
                propria Offerta. Possono essere aggiunti tanti dettagli quanti
                se ne ritengono necessari.
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
              <h5 style="margin-top: 10px">
                Con il tasto <span class="legendLabel">SALVA</span> la gara
                viene salvata ma non pubblicata.
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
              <h5 style="margin-top: 10px">
                La gara, dopo essere stata pubblicata con il tasto
                <span class="legendLabel">PUBBLICA</span> non può più essere
                modificata.
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
            </div>
            <div *ngIf="loadedTender.tenderType !== 'PRIVATE'">
              <h5>
                <span class="legendTitle">COMPUTO METRICO</span> Per default il
                computo metrico è consultabile e scaricabile solo dalle imprese
                che partecipano alla gara d’appalto. Spuntando con il flag la
                casella <span class="legendLabel">VISIBILE PUBBLICAMENTE</span>,
                il Proponente, permette la consultazione del computo metrico a
                tutti i visitatori di Skimming che accedono alla sezione
                <u>GARE IN CORSO</u>.
              </h5>
              <h5>
                Per compilare il computo metrico scaricare
                il <strong>Template</strong> (<i>matrice di computo</i>)
                mediante l'apposita funzione
                <span class="legendLabel">SCARICA TEMPLATE</span> salvarlo in
                una cartella a scelta del proprio computer e procedere in uno
                dei seguenti modi:
              </h5>
              <ol class="letter" type="a">
                <li>
                  compilando direttamente il file di excell (<strong
                    ><i>Template</i></strong
                  >) mediante inserimento di tutte le voci e dati necessari.
                </li>
                <li>
                  caricando sul <strong><i>Template</i></strong
                  >, con copia e incolla, un <i>computo già redatto</i> con
                  altro programma utilizzato abitualmente, seguendo due regole
                  fondamentali:
                  <ol class="number" type="a">
                    <li>
                      il computo già redatto con altro programma deve essere un
                      <u>file di excel</u>
                    </li>
                    <li>
                      le colonne del "computo già redatto con altro programma"
                      devono essere copiate nello stesso ordine proposto dal
                      <strong><i>Template</i></strong> (matrice) e nella
                      posizione della colonna giusta per permettere a Skimming
                      di processare i dati caricati.
                    </li>
                  </ol>
                </li>
              </ol>
              <h5 style="text-align: center; margin-bottom: 10px">
                <span class="column-name">Num. Ord.</span>
                <span class="column-name">Codice</span>
                <span class="column-name">Descrizione</span>
                <span class="column-name">Par.Ug.</span>
                <span class="column-name">Lungh.</span>
                <span class="column-name">Largh.</span>
                <span class="column-name">h/peso</span>
                <span class="column-name">Unità di. misura</span>
                <span class="column-name">Note Proponente</span>
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
              <h5>
                <strong
                  >IMPORTANTE!!!!!!! La colonna quantità non deve
                  <u>mai</u> essere copiata. Viene calcolata e processata
                  direttamente dal Template di Skimming.</strong
                >
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
              <h5>
                <strong
                  >Istuzioni su come procedere sono presenti nel file excel
                  scaricabile attraverso apposito pulsante
                  <em>Scarica Istruzioni</em>.</strong
                >
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
              <h5>
                Ultimate le operazioni sopraesposte il "File" va ricaricato su
                Skimming utilizzando l'apposita funzione <span
                  class="legendLabel"
                  >CARICA COMPUTO.</span
                >
              </h5>
              <h5 style="margin-top: 10px">
                Con il tasto <span class="legendLabel">SALVA</span> il computo
                viene salvato ma non pubblicato.
              </h5>
              <h5 style="margin-top: 10px">
                Il tasto <span class="legendLabel">SCARICA COMPUTO</span> serve
                al Proponente che dopo aver fatto <u>SALVA</u> vuole visionare
                quello che ha caricato, oppure per completare o modificare la
                redazione del computo.
              </h5>
              <h5 style="margin-top: 10px">
                Il computo, ma più in generale tutta la gara, dopo essere stata
                pubblicata con il tasto
                <span class="legendLabel">PUBBLICA</span> non può più essere
                modificata.
              </h5>
              <h5 style="margin-top: 10px">
                Il computo sarà scaricato dall'Offerente che
                compilerà <u>obbligatoriamente</u> la colonna con i propri
                prezzi e <u>facoltativamente</u> la colonna Note Offerente.
              </h5>
              <h5>
                L'offerente  non potrà apportare alcuna modifica alle colonne
                compilate dal Proponente in quanto congelate.
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
            </div>
            <h5>
              <span class="legendTitle">RIFIUTA LA GARA</span> Con il tasto
              <span class="legendLabel">RIFIUTA LA GARA</span> il Proponente non
              assegna la vittoria a nessuna impresa concorrente e chiude la gara
              in corso, seguiranno mail di congedo a tutte le imprese
              concorrenti con la comunicazione della chiusura gara senza
              assegnazione del vincitore.
            </h5>
            <div
              class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 10px"
            ></div>
            <h5>
              <span class="legendTitle">ACCETTA IL VINCITORE</span> Con il tasto
              <span class="legendLabel">ACCETTA IL VINCITORE</span> il
              Proponente assegna la vittoria ad un Impresa che sarà
              immediatamente informata tramite mail da Skimming, seguiranno mail
              di congedo alle imprese concorrenti con la comunicazione dell’
              assegnazione della gara ad altro soggetto concorrente.<span
                *ngIf="loadedTender.tenderType === 'PRIVATE'"
                >Con questa azione si attiverà l’attribuzione di un codice
                alfanumerico che permetterà al proponente di beneficiare di
                eventuali bonus/omaggi previsti nella sezione Promozioni attive.
                Parallelamente si attiveranno tutte le procedure di ristoro che
                sono: al 2° classificato (con minimo tre concorrenti) voucher di
                ristoro per partecipare ad un’altra gara, ai due Offerenti
                invitati dal Proponente voucher di ristoro per partecipare ad
                un’altra gara (a condizione che non occupino la prima e l’ultima
                posizione di classifica).</span
              >
            </h5>
            <div
              class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 10px"
            ></div>
            <h5>
              <span class="legendTitle">DOMANDE E RISPOSTE</span> Cliccando su
              questo Link compare una maschera ove sono possibili le seguenti
              operazioni:
            </h5>
            <ol class="number" type="a">
              <li>
                Ricercare eventuali domande e risposte già inserite mediante il
                tasto <span class="legendLabel">CERCA</span>
              </li>
              <li>
                Anticipare tutte quelle domande che il Proponente ritiene gli
                verrebbero poste più frequentemente dagli Utenti, cliccando sul
                Link <span class="legendLabel">FAI UNA DOMANDA</span>,
                compilando il form che gli si propone e pubblicandolo con
                <span class="legendLabel">INVIA DOMANDA</span>.
              </li>
              <li>
                Rispondere alle domande formulate compilando il form che si apre
                cliccando sul link
                <span class="legendLabel">RISPONDI ALLA DOMANDA</span>,
                compilando il form che gli si propone e pubblicandolo con
                <span class="legendLabel">INVIA RISPOSTA</span>.
              </li>
            </ol>
            <div *ngIf="loadedTender.tenderType === 'PRIVATE'">
              <h5>
                <span class="legendTitle">FAI UPGRADE</span> Con questa funzione
                è possibile traslare in modalità “Gara Professionisti” ed avere
                così i seguenti benefici: possibilità di inserire un computo
                metrico dettagliato, possibilità di scegliere se mostrare la
                migliore offerta, possibilità di aggiungere un numero illimitato
                di allegati rispettando la capacità massima di memoria in Mb
                previsti.
              </h5>
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fusion-sep-clear"></div>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 30px"
    ></div>

    <h3 style="font-family: Montserrat, Arial, Helvetica, sans-serif">
      <strong>{{ tenderForm.get("title").value }}</strong>
    </h3>
    <style>
      #statusContainer {
        display: flex;
        justify-content: space-between;
      }
      #condivisionLabel {
        padding: 3px 10px;
        font-size: 22px;
        color: var(--ng-app-theme-yellow-color);
      }

      @media only screen and (max-width: 910px) {
        #statusContainer {
          flex-direction: column !important;
        }

        #condivisionLabel {
          padding: 0px !important;
        }
      }
    </style>
    <div id="statusContainer">
      <div style="font-family: Montserrat, Arial, Helvetica, sans-serif">
        <strong
          style="
            background-color: var(--ng-app-theme-yellow-color);
            padding: 3px 10px;
            font-size: 22px;
            color: #ffffff;
          "
          >{{ tenderStatusDescr }}</strong
        >
      </div>
      <div
        style="
          font-family: Montserrat, Arial, Helvetica, sans-serif;
          cursor: pointer;
        "
        *ngIf="isShareVisible()"
      >
        <div
          style="text-align: right"
          (click)="sharingEmailRequestModal.open()"
        >
          <strong id="condivisionLabel">Condividi</strong>
          <span
            style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
            class="icon-wrapper circle-no"
            ><i
              class="fusion-li-icon fa-share-alt fas"
              style="color: var(--ng-app-theme-yellow-color)"
            ></i
          ></span>
        </div>
        <div
          *ngIf="loadedTender.tenderType === 'PRIVATE'"
          style="text-align: right"
          (click)="searchDesigner()"
        >
          <strong id="condivisionLabel">Cerca un progettista</strong>
          <span
            style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
            class="icon-wrapper circle-no"
            ><i
              class="fusion-li-icon fa-search fas"
              style="color: var(--ng-app-theme-yellow-color)"
            ></i
          ></span>
        </div>
      </div>
      <div
        *ngIf="loadedTender.customer"
        style="font-family: Montserrat, Arial, Helvetica, sans-serif"
      >
        <strong id="condivisionLabel"
          >Condivisa da: {{ loadedTender.customer }}</strong
        >
      </div>
    </div>

    <style type="text/css">
      .fusion-accordian #accordion-1423-1 .panel-title a .fa-fusion-box {
        color: #ffffff;
      }

      .fusion-accordian #accordion-1423-1 .panel-title a .fa-fusion-box:before {
        font-size: 16px;
        width: 16px;
      }

      .fusion-accordian #accordion-1423-1 .panel-title a {
        font-size: 18px;
      }

      .fusion-accordian #accordion-1423-1 .fa-fusion-box {
        background-color: #333333;
        border-color: #333333;
      }

      .fusion-accordian #accordion-1423-1 .panel-title a:hover,
      #accordion-1423-1 .fusion-toggle-boxed-mode:hover .panel-title a {
        color: #ffa626;
      }

      .fusion-accordian #accordion-1423-1 .panel-title .active .fa-fusion-box,
      .fusion-accordian #accordion-1423-1 .panel-title a:hover .fa-fusion-box {
        background-color: #ffa626 !important;
        border-color: #ffa626 !important;
      }

      .button-default-disabled {
        background-image: linear-gradient(
          to top,
          var(--ng-app-dark-grey-color),
          var(--ng-app-dark-grey-color)
        );
        cursor: auto;
      }

      a.button-default-disabled span {
        color: #ffffff !important;
      }
    </style>
    <button
      class="fusion-button-wrapper fusion-alignright"
      style="border: 0"
      *ngIf="checkDate(loadedTender.expectedEndDate) && feedbackExists"
      (click)="getFeedbackLink(loadedTender.tenderId)"
    >
      <style type="text/css">
        .fusion-button.button-2 {
          border-radius: 0px;
        }
      </style>
      <a
        class="
          button-default button-flat
          fusion-button fusion-button-default-size fusion-button-default-type
        "
        target="_self"
        ><span class="fusion-button-text">INVIA FEEDBACK</span></a
      >
    </button>

    <div class="fusion-sep-clear"></div>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 40px"
    ></div>
    <p><strong>INFORMAZIONI GENERALI GARA</strong></p>
    <div class="fusion-sep-clear"></div>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 0px"
    ></div>

    <form [formGroup]="tenderForm" id="tender-appform">
      <div *ngIf="loadedTender.tenderStatus === 'ACCEPTED'">
        <ul
          class="fusion-checklist fusion-checklist-1"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <span
              style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
              class="icon-wrapper circle-no"
              ><i class="fusion-li-icon fa-info fas" style="color: #333333"></i
            ></span>
            <div class="fusion-li-item-content" style="margin-left: 38.4px">
              <p>NUMERO SERIALE</p>
            </div>
          </li>
        </ul>
        <div class="fusion-button-wrapper fusion-align-block">
          <style type="text/css">
            .fusion-button.button-1 .fusion-button-text,
            .fusion-button.button-1 i {
              color: #a5a5a5;
            }

            .fusion-button.button-1 .fusion-button-icon-divider {
              border-color: #a5a5a5;
            }

            .fusion-button.button-1:hover .fusion-button-text,
            .fusion-button.button-1:hover i,
            .fusion-button.button-1:focus .fusion-button-text,
            .fusion-button.button-1:focus i,
            .fusion-button.button-1:active .fusion-button-text,
            .fusion-button.button-1:active {
              color: #ffffff;
            }

            .fusion-button.button-1:hover .fusion-button-icon-divider,
            .fusion-button.button-1:hover .fusion-button-icon-divider,
            .fusion-button.button-1:active .fusion-button-icon-divider {
              border-color: #ffffff;
            }

            .fusion-button.button-1:hover,
            .fusion-button.button-1:focus,
            .fusion-button.button-1:active {
              border-color: #ffffff;
            }

            .fusion-button.button-1 {
              border-color: #333333;
              border-radius: 0px;
            }

            .fusion-button.button-1 {
              background: #ffffff;
            }

            .fusion-button.button-1:hover,
            .button-1:focus,
            .fusion-button.button-1:active {
              background: #ffffff;
            }
          </style>
          <input
            type="text"
            placeholder="Numero Seriale"
            formControlName="serialNumber"
            id="serialNumber"
            (click)="resetError()"
            maxlength="150"
          />
        </div>
        <div class="fusion-sep-clear"></div>
      </div>

      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"
      ></div>

      <ul
        class="fusion-checklist fusion-checklist-1"
        style="font-size: 16px; line-height: 27.2px"
      >
        <li class="fusion-li-item">
          <span
            style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
            class="icon-wrapper circle-no"
            ><i class="fusion-li-icon fa-info fas" style="color: #333333"></i
          ></span>
          <div class="fusion-li-item-content" style="margin-left: 38.4px">
            <p>TITOLO DELLA GARA*</p>
          </div>
        </li>
      </ul>
      <div class="fusion-button-wrapper fusion-align-block">
        <style type="text/css">
          .fusion-button.button-1 .fusion-button-text,
          .fusion-button.button-1 i {
            color: #a5a5a5;
          }

          .fusion-button.button-1 .fusion-button-icon-divider {
            border-color: #a5a5a5;
          }

          .fusion-button.button-1:hover .fusion-button-text,
          .fusion-button.button-1:hover i,
          .fusion-button.button-1:focus .fusion-button-text,
          .fusion-button.button-1:focus i,
          .fusion-button.button-1:active .fusion-button-text,
          .fusion-button.button-1:active {
            color: #ffffff;
          }

          .fusion-button.button-1:hover .fusion-button-icon-divider,
          .fusion-button.button-1:hover .fusion-button-icon-divider,
          .fusion-button.button-1:active .fusion-button-icon-divider {
            border-color: #ffffff;
          }

          .fusion-button.button-1:hover,
          .fusion-button.button-1:focus,
          .fusion-button.button-1:active {
            border-color: #ffffff;
          }

          .fusion-button.button-1 {
            border-color: #333333;
            border-radius: 0px;
          }

          .fusion-button.button-1 {
            background: #ffffff;
          }

          .fusion-button.button-1:hover,
          .button-1:focus,
          .fusion-button.button-1:active {
            background: #ffffff;
          }
        </style>
        <input
          type="text"
          placeholder="Titolo"
          formControlName="title"
          id="title"
          (click)="resetError()"
          required
          maxlength="150"
        />
        <div
          [ngStyle]="{
            visibility:
              tenderForm.get('title').valid || tenderForm.get('title').pristine
                ? 'hidden'
                : 'visible'
          }"
          class="ng-alert"
        >
          Inserire un titolo per la gara.
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"
      ></div>
      <ul
        class="fusion-checklist fusion-checklist-2"
        style="font-size: 16px; line-height: 27.2px"
      >
        <li class="fusion-li-item">
          <span
            style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
            class="icon-wrapper circle-no"
            ><i
              class="fusion-li-icon fa-align-center fas"
              style="color: #333333"
            ></i
          ></span>
          <div class="fusion-li-item-content" style="margin-left: 38.4px">
            <p>BREVE DESCRIZIONE*</p>
          </div>
        </li>
      </ul>
      <div class="fusion-button-wrapper fusion-align-block">
        <style type="text/css">
          .fusion-button.button-2 .fusion-button-text,
          .fusion-button.button-2 i {
            color: #a5a5a5;
          }

          .fusion-button.button-2 .fusion-button-icon-divider {
            border-color: #a5a5a5;
          }

          .fusion-button.button-2:hover .fusion-button-text,
          .fusion-button.button-2:hover i,
          .fusion-button.button-2:focus .fusion-button-text,
          .fusion-button.button-2:focus i,
          .fusion-button.button-2:active .fusion-button-text,
          .fusion-button.button-2:active {
            color: #ffffff;
          }

          .fusion-button.button-2:hover .fusion-button-icon-divider,
          .fusion-button.button-2:hover .fusion-button-icon-divider,
          .fusion-button.button-2:active .fusion-button-icon-divider {
            border-color: #ffffff;
          }

          .fusion-button.button-2:hover,
          .fusion-button.button-2:focus,
          .fusion-button.button-2:active {
            border-color: #ffffff;
          }

          .fusion-button.button-2 {
            border-color: #333333;
            border-radius: 0px;
          }

          .fusion-button.button-2 {
            background: #ffffff;
          }

          .fusion-button.button-2:hover,
          .button-2:focus,
          .fusion-button.button-2:active {
            background: #ffffff;
          }
        </style>
        <textarea
          type="text"
          placeholder="Descrizione"
          formControlName="description"
          id="description"
          (click)="resetError()"
          required
          maxlength="500"
        ></textarea>
        <div
          [ngStyle]="{
            visibility:
              tenderForm.get('description').valid ||
              tenderForm.get('description').pristine
                ? 'hidden'
                : 'visible'
          }"
          class="ng-alert"
        >
          Inserire una descrizione per la gara.
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"
      ></div>

      <ul
        class="fusion-checklist fusion-checklist-3"
        style="font-size: 16px; line-height: 27.2px"
      >
        <li class="fusion-li-item">
          <span
            style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
            class="icon-wrapper circle-no"
            ><i
              class="fusion-li-icon fa-building fas"
              style="color: #333333"
            ></i
          ></span>
          <div class="fusion-li-item-content" style="margin-left: 38.4px">
            <p>CATEGORIA*</p>
          </div>
        </li>
      </ul>
      <div
        class="fusion-builder-row fusion-builder-row-inner fusion-row"
        id="category"
      >
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_5
            fusion-builder-nested-column-1
            fusion-one-fifth
            fusion-column-first
            1_5
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 20%;
            width: calc(20% - ((4% + 4% + 4% + 4%) * 0.2));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-1 ng-category-box {{
              constructionBox
            }}"
            style="
              padding: 5px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
            (click)="selectConstruction()"
          >
            <span
              class="
                fusion-imageframe
                imageframe-none imageframe-1
                hover-type-none
              "
              ><img
                src="/wp-content/uploads/2015/12/Costruzione-300x300-1.png"
                width="300"
                height="300"
                alt=""
                title="Costruzione 300&#215;300"
                class="img-responsive wp-image-1308"
            /></span>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_5
            fusion-builder-nested-column-2
            fusion-one-fifth
            1_5
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 20%;
            width: calc(20% - ((4% + 4% + 4% + 4%) * 0.2));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-2 ng-category-box {{
              renovationBox
            }}"
            style="
              padding: 5px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
            (click)="selectRenovation()"
          >
            <span
              class="
                fusion-imageframe
                imageframe-none imageframe-2
                hover-type-none
              "
              ><img
                src="/wp-content/uploads/2020/02/Ristrutturazioni-300x300-1.png"
                width="300"
                height="300"
                alt=""
                title="Ristrutturazioni 300&#215;300"
                class="img-responsive wp-image-1307"
            /></span>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_5
            fusion-builder-nested-column-3
            fusion-one-fifth
            1_5
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 20%;
            width: calc(20% - ((4% + 4% + 4% + 4%) * 0.2));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-3 ng-category-box {{
              systemBox
            }}"
            style="
              padding: 5px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
            (click)="selectSystem()"
          >
            <span
              class="
                fusion-imageframe
                imageframe-none imageframe-3
                hover-type-none
              "
              ><img
                src="/wp-content/uploads/2015/06/Impianti-300x300-1.png"
                width="300"
                height="300"
                alt=""
                title="Impianti 300&#215;300"
                class="img-responsive wp-image-1310"
            /></span>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_5
            fusion-builder-nested-column-4
            fusion-one-fifth
            1_5
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 20%;
            width: calc(20% - ((4% + 4% + 4% + 4%) * 0.2));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-4 ng-category-box {{
              excavationBox
            }}"
            style="
              padding: 5px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
            (click)="selectExcavation()"
          >
            <span
              class="
                fusion-imageframe
                imageframe-none imageframe-4
                hover-type-none
              "
              ><img
                src="/wp-content/uploads/2015/12/Scavi-300x300-1.png"
                width="300"
                height="300"
                alt=""
                title="Scavi 300&#215;300"
                class="img-responsive wp-image-1309"
            /></span>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_5
            fusion-builder-nested-column-5
            fusion-one-fifth
            fusion-column-last
            1_5
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 20%;
            width: calc(20% - ((4% + 4% + 4% + 4%) * 0.2));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-5 ng-category-box {{
              demolitionBox
            }}"
            style="
              padding: 5px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
            (click)="selectDemolition()"
          >
            <span
              class="
                fusion-imageframe
                imageframe-none imageframe-5
                hover-type-none
              "
              ><img
                src="/wp-content/uploads/2015/06/Demolizioni-300x300-1.png"
                width="300"
                height="300"
                alt=""
                title="Demolizioni 300&#215;300"
                class="img-responsive wp-image-1311"
            /></span>
          </div>
        </div>
      </div>
      <div
        [ngStyle]="{
          visibility: categoryError === 'no_error' ? 'hidden' : 'visible'
        }"
        class="ng-alert"
      >
        {{ categoryError }}
      </div>

      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 30px"
      ></div>
      <p><strong>INFORMAZIONI CONTATTO</strong></p>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"
      ></div>

      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-11
            fusion-one-half
            fusion-column-first
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-11"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-1"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <span
                  style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                  class="icon-wrapper circle-no"
                  ><i
                    class="fusion-li-icon fa-address-card fas"
                    style="color: #333333"
                  ></i
                ></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  <p>NOME* (NP)</p>
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-4 .fusion-button-text,
                .fusion-button.button-4 i {
                  color: #333333;
                }

                .fusion-button.button-4 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-4:hover .fusion-button-text,
                .fusion-button.button-4:hover i,
                .fusion-button.button-4:focus .fusion-button-text,
                .fusion-button.button-4:focus i,
                .fusion-button.button-4:active .fusion-button-text,
                .fusion-button.button-4:active {
                  color: #ffffff;
                }

                .fusion-button.button-4:hover .fusion-button-icon-divider,
                .fusion-button.button-4:hover .fusion-button-icon-divider,
                .fusion-button.button-4:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-4:hover,
                .fusion-button.button-4:focus,
                .fusion-button.button-4:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-4 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-4 {
                  background: #ffffff;
                }

                .fusion-button.button-4:hover,
                .button-4:focus,
                .fusion-button.button-4:active {
                  background: #ffffff;
                }
              </style>
              <input
                type="text"
                formControlName="contactName"
                id="contactName"
                (click)="resetError()"
              />
              <div
                [ngStyle]="{
                  visibility:
                    tenderForm.get('contactName').valid ||
                    tenderForm.get('contactName').pristine
                      ? 'hidden'
                      : 'visible'
                }"
                class="ng-alert"
              >
                Il nome è obbligatorio.
              </div>
            </div>
            <div class="fusion-sep-clear"></div>
            <div
              class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 0px"
            ></div>
            <ul
              class="fusion-checklist fusion-checklist-2"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <span
                  style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                  class="icon-wrapper circle-no"
                  ><i
                    class="fusion-li-icon fa fa-envelope"
                    style="color: #333333"
                  ></i
                ></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  <p>EMAIL* (NP)</p>
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-5 .fusion-button-text,
                .fusion-button.button-5 i {
                  color: #333333;
                }

                .fusion-button.button-5 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-5:hover .fusion-button-text,
                .fusion-button.button-5:hover i,
                .fusion-button.button-5:focus .fusion-button-text,
                .fusion-button.button-5:focus i,
                .fusion-button.button-5:active .fusion-button-text,
                .fusion-button.button-5:active {
                  color: #ffffff;
                }

                .fusion-button.button-5:hover .fusion-button-icon-divider,
                .fusion-button.button-5:hover .fusion-button-icon-divider,
                .fusion-button.button-5:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-5:hover,
                .fusion-button.button-5:focus,
                .fusion-button.button-5:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-5 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-5 {
                  background: #ffffff;
                }

                .fusion-button.button-5:hover,
                .button-5:focus,
                .fusion-button.button-5:active {
                  background: #ffffff;
                }
              </style>
              <input
                type="email"
                formControlName="contactEmail"
                id="contactEmail"
                (click)="resetError()"
              />
              <div
                [ngStyle]="{
                  visibility:
                    tenderForm.get('contactEmail').valid ||
                    tenderForm.get('contactEmail').pristine
                      ? 'hidden'
                      : 'visible'
                }"
                class="ng-alert"
              >
                Inserire un'email valida.
              </div>
            </div>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-12
            fusion-one-half
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-12"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-4"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <span
                  style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                  class="icon-wrapper circle-no"
                  ><i
                    class="fusion-li-icon fa fa-phone"
                    style="color: #333333"
                  ></i
                ></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  <p>TELEFONO* (NP)</p>
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-7 .fusion-button-text,
                .fusion-button.button-7 i {
                  color: #333333;
                }

                .fusion-button.button-7 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-7:hover .fusion-button-text,
                .fusion-button.button-7:hover i,
                .fusion-button.button-7:focus .fusion-button-text,
                .fusion-button.button-7:focus i,
                .fusion-button.button-7:active .fusion-button-text,
                .fusion-button.button-7:active {
                  color: #ffffff;
                }

                .fusion-button.button-7:hover .fusion-button-icon-divider,
                .fusion-button.button-7:hover .fusion-button-icon-divider,
                .fusion-button.button-7:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-7:hover,
                .fusion-button.button-7:focus,
                .fusion-button.button-7:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-7 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-7 {
                  background: #ffffff;
                }

                .fusion-button.button-7:hover,
                .button-7:focus,
                .fusion-button.button-7:active {
                  background: #ffffff;
                }
              </style>
              <input
                type="text"
                formControlName="contactPhone"
                id="contactPhone"
                (click)="resetError()"
              />
              <div
                [ngStyle]="{
                  visibility:
                    tenderForm.get('contactPhone').valid ||
                    tenderForm.get('contactPhone').pristine
                      ? 'hidden'
                      : 'visible'
                }"
                class="ng-alert"
              >
                Inserire un numero di telefono valido.
              </div>
            </div>
            <ul
              class="fusion-checklist fusion-checklist-4"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  <p></p>
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-7 .fusion-button-text,
                .fusion-button.button-7 i {
                  color: #333333;
                }

                .fusion-button.button-7 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-7:hover .fusion-button-text,
                .fusion-button.button-7:hover i,
                .fusion-button.button-7:focus .fusion-button-text,
                .fusion-button.button-7:focus i,
                .fusion-button.button-7:active .fusion-button-text,
                .fusion-button.button-7:active {
                  color: #ffffff;
                }

                .fusion-button.button-7:hover .fusion-button-icon-divider,
                .fusion-button.button-7:hover .fusion-button-icon-divider,
                .fusion-button.button-7:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-7:hover,
                .fusion-button.button-7:focus,
                .fusion-button.button-7:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-7 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-7 {
                  background: #ffffff;
                }

                .fusion-button.button-7:hover,
                .button-7:focus,
                .fusion-button.button-7:active {
                  background: #ffffff;
                }
              </style>
            </div>
          </div>
        </div>
      </div>

      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>
      <p><strong>UBICAZIONE CANTIERE</strong></p>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"
      ></div>

      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-22
            fusion-one-half
            fusion-column-first
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4% + 4%) * 0.5));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-14"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <span
                  style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                  class="icon-wrapper circle-no"
                  ><i
                    class="fusion-li-icon fa fa-city"
                    style="color: #333333"
                  ></i
                ></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  COMUNE* (NP)
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-16 .fusion-button-text,
                .fusion-button.button-16 i {
                  color: #333333;
                }

                .fusion-button.button-16 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-16:hover .fusion-button-text,
                .fusion-button.button-16:hover i,
                .fusion-button.button-16:focus .fusion-button-text,
                .fusion-button.button-16:focus i,
                .fusion-button.button-16:active .fusion-button-text,
                .fusion-button.button-16:active {
                  color: #ffffff;
                }

                .fusion-button.button-16:hover .fusion-button-icon-divider,
                .fusion-button.button-16:hover .fusion-button-icon-divider,
                .fusion-button.button-16:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-16:hover,
                .fusion-button.button-16:focus,
                .fusion-button.button-16:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-16 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-16 {
                  background: #ffffff;
                }

                .fusion-button.button-16:hover,
                .button-16:focus,
                .fusion-button.button-16:active {
                  background: #ffffff;
                }
              </style>
              <input
                type="text"
                formControlName="city"
                id="city"
                (click)="resetError()"
              />
              <div
                [ngStyle]="{
                  visibility:
                    tenderForm.get('city').valid ||
                    tenderForm.get('city').pristine
                      ? 'hidden'
                      : 'visible'
                }"
                class="ng-alert"
              >
                La città è obbligatoria.
              </div>
            </div>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_4
            fusion-builder-nested-column-23
            fusion-one-fourth
            1_4
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 25%;
            width: calc(25% - ((4% + 4%) * 0.25));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-23"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-15"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <span
                  style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                  class="icon-wrapper circle-no"
                  ><i
                    class="fusion-li-icon fa fa-city"
                    style="color: #333333"
                  ></i
                ></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  PROVINCIA* (NP)
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-17 .fusion-button-text,
                .fusion-button.button-17 i {
                  color: #333333;
                }

                .fusion-button.button-17 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-17:hover .fusion-button-text,
                .fusion-button.button-17:hover i,
                .fusion-button.button-17:focus .fusion-button-text,
                .fusion-button.button-17:focus i,
                .fusion-button.button-17:active .fusion-button-text,
                .fusion-button.button-17:active {
                  color: #ffffff;
                }

                .fusion-button.button-17:hover .fusion-button-icon-divider,
                .fusion-button.button-17:hover .fusion-button-icon-divider,
                .fusion-button.button-17:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-17:hover,
                .fusion-button.button-17:focus,
                .fusion-button.button-17:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-17 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-17 {
                  background: #ffffff;
                }

                .fusion-button.button-17:hover,
                .button-17:focus,
                .fusion-button.button-17:active {
                  background: #ffffff;
                }
              </style>
              <select
                formControlName="provinceCode"
                id="provinceCode"
                required
                (click)="resetError()"
                required
              >
                <option [ngValue]="null"></option>
                <option
                  [ngValue]="province.code"
                  *ngFor="let province of provinces"
                >
                  {{ province.description }}
                </option>
              </select>
              <div
                [ngStyle]="{
                  visibility:
                    tenderForm.get('provinceCode').valid ||
                    tenderForm.get('provinceCode').pristine
                      ? 'hidden'
                      : 'visible'
                }"
                class="ng-alert"
              >
                Provincia obbligatoria
              </div>
            </div>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_4
            fusion-builder-nested-column-24
            fusion-one-fourth
            fusion-column-last
            1_4
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 25%;
            width: calc(25% - ((4% + 4%) * 0.25));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-24"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-16"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <span
                  style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                  class="icon-wrapper circle-no"
                  ><i
                    class="fusion-li-icon fa fa-city"
                    style="color: #333333"
                  ></i
                ></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  CAP* (NP)
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-18 .fusion-button-text,
                .fusion-button.button-18 i {
                  color: #333333;
                }

                .fusion-button.button-18 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-18:hover .fusion-button-text,
                .fusion-button.button-18:hover i,
                .fusion-button.button-18:focus .fusion-button-text,
                .fusion-button.button-18:focus i,
                .fusion-button.button-18:active .fusion-button-text,
                .fusion-button.button-18:active {
                  color: #ffffff;
                }

                .fusion-button.button-18:hover .fusion-button-icon-divider,
                .fusion-button.button-18:hover .fusion-button-icon-divider,
                .fusion-button.button-18:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-18:hover,
                .fusion-button.button-18:focus,
                .fusion-button.button-18:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-18 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-18 {
                  background: #ffffff;
                }

                .fusion-button.button-18:hover,
                .button-18:focus,
                .fusion-button.button-18:active {
                  background: #ffffff;
                }
              </style>
              <input
                type="text"
                formControlName="zipCode"
                id="zipCode"
                (click)="resetError()"
              />
              <div
                [ngStyle]="{
                  visibility:
                    tenderForm.get('zipCode').valid ||
                    tenderForm.get('zipCode').pristine
                      ? 'hidden'
                      : 'visible'
                }"
                class="ng-alert"
              >
                Il CAP è obbligatorio.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_2_3
            fusion-builder-nested-column-25
            fusion-two-third
            fusion-column-first
            2_3
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 66.66%;
            width: calc(66.66% - ((4%) * 0.6666));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-25"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-17"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <span
                  style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                  class="icon-wrapper circle-no"
                  ><i
                    class="fusion-li-icon fa fa-road"
                    style="color: #333333"
                  ></i
                ></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  INDIRIZZO* (NP)
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-19 .fusion-button-text,
                .fusion-button.button-19 i {
                  color: #333333;
                }

                .fusion-button.button-19 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-19:hover .fusion-button-text,
                .fusion-button.button-19:hover i,
                .fusion-button.button-19:focus .fusion-button-text,
                .fusion-button.button-19:focus i,
                .fusion-button.button-19:active .fusion-button-text,
                .fusion-button.button-19:active {
                  color: #ffffff;
                }

                .fusion-button.button-19:hover .fusion-button-icon-divider,
                .fusion-button.button-19:hover .fusion-button-icon-divider,
                .fusion-button.button-19:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-19:hover,
                .fusion-button.button-19:focus,
                .fusion-button.button-19:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-19 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-19 {
                  background: #ffffff;
                }

                .fusion-button.button-19:hover,
                .button-19:focus,
                .fusion-button.button-19:active {
                  background: #ffffff;
                }
              </style>
              <input
                type="text"
                formControlName="address"
                id="address"
                (click)="resetError()"
              />
              <div
                [ngStyle]="{
                  visibility:
                    tenderForm.get('address').valid ||
                    tenderForm.get('address').pristine
                      ? 'hidden'
                      : 'visible'
                }"
                class="ng-alert"
              >
                L'indirizzo è obbligatorio.
              </div>
            </div>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_3
            fusion-builder-nested-column-26
            fusion-one-third
            fusion-column-last
            1_3
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 33.33%;
            width: calc(33.33% - ((4%) * 0.3333));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-26"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-18"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <span
                  style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                  class="icon-wrapper circle-no"
                  ><i
                    class="fusion-li-icon fa fa-map-marked-alt"
                    style="color: #333333"
                  ></i
                ></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  N° CIVICO (NP)
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-20 .fusion-button-text,
                .fusion-button.button-20 i {
                  color: #333333;
                }

                .fusion-button.button-20 .fusion-button-icon-divider {
                  border-color: #333333;
                }

                .fusion-button.button-20:hover .fusion-button-text,
                .fusion-button.button-20:hover i,
                .fusion-button.button-20:focus .fusion-button-text,
                .fusion-button.button-20:focus i,
                .fusion-button.button-20:active .fusion-button-text,
                .fusion-button.button-20:active {
                  color: #ffffff;
                }

                .fusion-button.button-20:hover .fusion-button-icon-divider,
                .fusion-button.button-20:hover .fusion-button-icon-divider,
                .fusion-button.button-20:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-20:hover,
                .fusion-button.button-20:focus,
                .fusion-button.button-20:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-20 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-20 {
                  background: #ffffff;
                }

                .fusion-button.button-20:hover,
                .button-20:focus,
                .fusion-button.button-20:active {
                  background: #ffffff;
                }
              </style>
              <input
                class="ng-app-input"
                type="text"
                formControlName="addressNumber"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none ng-space"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>
      <p><strong>DATE CANTIERE</strong></p>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"
      ></div>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-11
            fusion-one-half
            fusion-column-first
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-11"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-9"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <span
                  style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                  class="icon-wrapper circle-no"
                  ><i
                    class="fusion-li-icon fa-calendar-alt fas"
                    style="color: #333333"
                  ></i
                ></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  <p>DATA INIZIO LAVORI (Presunta)*</p>
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-8 .fusion-button-text,
                .fusion-button.button-8 i {
                  color: #c4c4c4;
                }

                .fusion-button.button-8 .fusion-button-icon-divider {
                  border-color: #c4c4c4;
                }

                .fusion-button.button-8:hover .fusion-button-text,
                .fusion-button.button-8:hover i,
                .fusion-button.button-8:focus .fusion-button-text,
                .fusion-button.button-8:focus i,
                .fusion-button.button-8:active .fusion-button-text,
                .fusion-button.button-8:active {
                  color: #ffffff;
                }

                .fusion-button.button-8:hover .fusion-button-icon-divider,
                .fusion-button.button-8:hover .fusion-button-icon-divider,
                .fusion-button.button-8:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-8:hover,
                .fusion-button.button-8:focus,
                .fusion-button.button-8:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-8 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-8 {
                  background: #fbfbfb;
                }

                .fusion-button.button-8:hover,
                .button-8:focus,
                .fusion-button.button-8:active {
                  background: #fbfbfb;
                }
              </style>
              <div
                class="fusion-button button-flat fusion-button-default-size button-custom button-9 fusion-button-span-yes fusion-button-default-type {{
                  startDateAlert
                }}"
              >
                <span
                  class="fusion-button-icon-divider button-icon-divider-left"
                  (click)="startDatePicker.open()"
                  ><i
                    class="fa-calendar-alt fas"
                    style="color: #c4c4c4 !important"
                  ></i
                ></span>
                <input
                  matInput
                  [matDatepicker]="startDatePicker"
                  placeholder="Data inizio"
                  formControlName="startDate"
                  id="startDate"
                  style="
                    border-bottom: none !important;
                    padding-left: 30px !important;
                    padding-bottom: 3px !important;
                    padding-top: 3px !important;
                  "
                />
                <mat-datepicker #startDatePicker></mat-datepicker>
              </div>
              <div
                [ngStyle]="{
                  visibility:
                    tenderForm.get('startDate').valid ||
                    tenderForm.get('startDate').pristine
                      ? 'hidden'
                      : 'visible'
                }"
                class="ng-alert"
              >
                Scegliere una data di inizio.
              </div>
            </div>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-12
            fusion-one-half
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-12"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-10"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <span
                  style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                  class="icon-wrapper circle-no"
                  ><i
                    class="fusion-li-icon fa-calendar-alt fas"
                    style="color: #333333"
                  ></i
                ></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  <p>DATA FINE LAVORI (Presunta)*</p>
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-9 .fusion-button-text,
                .fusion-button.button-9 i {
                  color: #c4c4c4;
                }

                .fusion-button.button-9 .fusion-button-icon-divider {
                  border-color: #c4c4c4;
                }

                .fusion-button.button-9:hover .fusion-button-text,
                .fusion-button.button-9:hover i,
                .fusion-button.button-9:focus .fusion-button-text,
                .fusion-button.button-9:focus i,
                .fusion-button.button-9:active .fusion-button-text,
                .fusion-button.button-9:active {
                  color: #fbfbfb;
                }

                .fusion-button.button-9:hover .fusion-button-icon-divider,
                .fusion-button.button-9:hover .fusion-button-icon-divider,
                .fusion-button.button-9:active .fusion-button-icon-divider {
                  border-color: #fbfbfb;
                }

                .fusion-button.button-9:hover,
                .fusion-button.button-9:focus,
                .fusion-button.button-9:active {
                  border-color: #fbfbfb;
                }

                .fusion-button.button-9 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-9 {
                  background: #fbfbfb;
                }

                .fusion-button.button-9:hover,
                .button-9:focus,
                .fusion-button.button-9:active {
                  background: #fbfbfb;
                }
              </style>
              <div
                class="fusion-button button-flat fusion-button-default-size button-custom button-9 fusion-button-span-yes fusion-button-default-type {{
                  endDateAlert
                }}"
              >
                <span
                  class="fusion-button-icon-divider button-icon-divider-left"
                  (click)="endDatePicker.open()"
                  ><i
                    class="fa-calendar-alt fas"
                    style="color: #c4c4c4 !important"
                  ></i
                ></span>
                <input
                  matInput
                  [matDatepicker]="endDatePicker"
                  placeholder="Data fine"
                  formControlName="endDate"
                  id="endDate"
                  style="
                    border-bottom: none !important;
                    padding-left: 30px !important;
                    padding-bottom: 3px !important;
                    padding-top: 3px !important;
                  "
                />
                <mat-datepicker #endDatePicker></mat-datepicker>
              </div>
              <div
                [ngStyle]="{
                  visibility:
                    tenderForm.get('endDate').valid ||
                    tenderForm.get('endDate').pristine
                      ? 'hidden'
                      : 'visible'
                }"
                class="ng-alert"
              >
                Scegliere una data di fine posteriore a quella di inizio.
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CLUSTER NAME-->
      <div *ngIf="loadedTender.tenderType === 'CLUSTER'" id="cluster-div">
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"
      ></div>
      <p><strong>CLUSTER SELEZIONATO</strong></p>
       <select  [disabled]="!canChangeTender"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="loadedTender.cluster"
                (click)="resetError()"
                [compareWith]="compareById"
              >
                <option
                  [ngValue]="null">
                </option>
                <option
                  [ngValue]="cluster"
                  *ngFor="let cluster of loadedTender.availableClusters"
                >
                  {{cluster.clusterName }}
                </option>
              </select>
         <div
          [ngStyle]="{
            visibility: clusterErrorMessage === 'no_error' ? 'hidden' : 'visible'
          }"
          class="ng-alert"
        >
          {{ clusterErrorMessage }}
        </div>
      <!-- END CLUSTER NAME-->
       <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>
      <!-- CLUSTER SECTORS-->
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"      ></div>

      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_2_3
          fusion-builder-nested-column-25
          fusion-two-third
          fusion-column-first
          2_3
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 66.66%;
          width: calc(66.66% - ((4%) * 0.6666));
          margin-right: 4%;
        "      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-25"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <p><strong>SETTORI CLUSTER</strong></p>
        </div>
      </div>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_3
          fusion-builder-nested-column-26
          fusion-one-third
          fusion-column-last
          1_3
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 33.33%;
          width: calc(33.33% - ((4%) * 0.3333));        "      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-26"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-28 {
                border-radius: 0px;
              }
            </style>
            <div *ngIf="canChangeTender">
              <a
                (click)="addClusterSector()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-28
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text">Aggiungi</span></a
              >
            </div>
          </div>
        </div>
      </div>

      <div *ngFor="let clusterSector of clusterSectors">
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 15px"
        ></div>
        <div class="specialization-container" id="cluster-sector">
          <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
            <div
              class="
                fusion-layout-column
                fusion_builder_column
                fusion_builder_column_1_2
                fusion-builder-nested-column-11
                fusion-one-half
                fusion-column-first
                1_2
              "
              style="
                margin-top: 0px;
                margin-bottom: 0px;
                width: 50%;
                width: calc(50% - ((4%) * 0.5));
                margin-right: 4%;
              "
            >
              <div
                class="fusion-column-wrapper fusion-column-wrapper-11"
                style="
                  padding: 0px 0px 0px 0px;
                  background-position: left top;
                  background-repeat: no-repeat;
                  -webkit-background-size: cover;
                  -moz-background-size: cover;
                  -o-background-size: cover;
                  background-size: cover;
                "
                data-bg-url=""
              >
                <ul
                  class="fusion-checklist fusion-checklist-15"
                  style="font-size: 16px; line-height: 27.2px"
                >
                  <li class="fusion-li-item">
                    <div class="fusion-li-item-content">SETTORE*</div>
                  </li>
                </ul>
                <div class="fusion-button-wrapper fusion-align-block">
                  <style type="text/css">
                    .fusion-button.button-17 .fusion-button-text,
                    .fusion-button.button-17 i {
                      color: #333333;
                    }

                    .fusion-button.button-17 .fusion-button-icon-divider {
                      border-color: #333333;
                    }

                    .fusion-button.button-17:hover .fusion-button-text,
                    .fusion-button.button-17:hover i,
                    .fusion-button.button-17:focus .fusion-button-text,
                    .fusion-button.button-17:focus i,
                    .fusion-button.button-17:active .fusion-button-text,
                    .fusion-button.button-17:active {
                      color: #ffffff;
                    }

                    .fusion-button.button-17:hover .fusion-button-icon-divider,
                    .fusion-button.button-17:hover .fusion-button-icon-divider,
                    .fusion-button.button-17:active
                      .fusion-button-icon-divider {
                      border-color: #ffffff;
                    }

                    .fusion-button.button-17:hover,
                    .fusion-button.button-17:focus,
                    .fusion-button.button-17:active {
                      border-color: #ffffff;
                    }

                    .fusion-button.button-17 {
                      border-color: #333333;
                      border-radius: 0px;
                    }

                    .fusion-button.button-17 {
                      background: #ffffff;
                    }

                    .fusion-button.button-17:hover,
                    .button-17:focus,
                    .fusion-button.button-17:active {
                      background: #ffffff;
                    }
                  </style>
                 <select
                  [disabled]="!canChangeTender"
                  [(ngModel)]="clusterSector.clusterSector.clusterSectorCode"
                  [ngModelOptions]="{ standalone: true }"
                  class="manual-validation-valid"
                >
                  <option [ngValue]="null">Selezione settore</option>
                  <option
                    [ngValue]="sectorType.code"
                    *ngFor="
                      let sectorType of sectorCompanyList
                    "
                  >
                    {{ sectorType.description }}
                  </option>
                </select>
                </div>
              </div>
            </div>
            <div
              class="
                fusion-layout-column
                fusion_builder_column
                fusion_builder_column_1_2
                fusion-builder-nested-column-12
                fusion-one-half
                fusion-column-last
                1_2
              "
              style="
                margin-top: 0px;
                margin-bottom: 0px;
                width: 50%;
                width: calc(50% - ((4%) * 0.5));
              "
            >
              <div
                class="fusion-column-wrapper fusion-column-wrapper-12"
                style="
                  padding: 0px 0px 0px 0px;
                  background-position: left top;
                  background-repeat: no-repeat;
                  -webkit-background-size: cover;
                  -moz-background-size: cover;
                  -o-background-size: cover;
                  background-size: cover;
                "
                data-bg-url=""
              >
                <ul
                  class="fusion-checklist fusion-checklist-16"
                  style="font-size: 16px; line-height: 27.2px"
                >
                  <li class="fusion-li-item">
                    <div class="fusion-li-item-content">MAX PARTECIPANTI*</div>
                  </li>
                </ul>
                <div class="fusion-button-wrapper fusion-align-block">
                  <style type="text/css">
                    .fusion-button.button-18 .fusion-button-text,
                    .fusion-button.button-18 i {
                      color: #333333;
                    }

                    .fusion-button.button-18 .fusion-button-icon-divider {
                      border-color: #333333;
                    }

                    .fusion-button.button-18:hover .fusion-button-text,
                    .fusion-button.button-18:hover i,
                    .fusion-button.button-18:focus .fusion-button-text,
                    .fusion-button.button-18:focus i,
                    .fusion-button.button-18:active .fusion-button-text,
                    .fusion-button.button-18:active {
                      color: #ffffff;
                    }

                    .fusion-button.button-18:hover .fusion-button-icon-divider,
                    .fusion-button.button-18:hover .fusion-button-icon-divider,
                    .fusion-button.button-18:active
                      .fusion-button-icon-divider {
                      border-color: #ffffff;
                    }

                    .fusion-button.button-18:hover,
                    .fusion-button.button-18:focus,
                    .fusion-button.button-18:active {
                      border-color: #ffffff;
                    }

                    .fusion-button.button-18 {
                      border-color: #333333;
                      border-radius: 0px;
                    }

                    .fusion-button.button-18 {
                      background: #ffffff;
                    }

                    .fusion-button.button-18:hover,
                    .button-18:focus,
                    .fusion-button.button-18:active {
                      background: #ffffff;
                    }
                  </style>
                  <input
                    class="manual-validation-valid"
                    class="ng-app-input"
                    type="text"
                    [(ngModel)]="clusterSector.clusterSector.maxParticipants"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="!canChangeTender"
                  />
                  <!-- (ngModelChange)="setMinimumRequirementValue(minimumRequirement)" -->
                </div>
              </div>
            </div>
          </div>

          <style>
            a {
              color: #333333;
            }
            a:hover {
              color: var(--ng-app-theme-yellow-color);
            }
          </style>
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_4
              fusion-builder-nested-column-24
              fusion-one-fourth
              fusion-column-last
              1_4
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 23%;
              width: calc(23% - ((4% + 4%) * 0.25));
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-24"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              "
              data-bg-url=""
            >
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 40px"
              ></div>
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-28 {
                    border-radius: 0px;
                  }
                </style>
                <div *ngIf="canChangeTender">
                  <a
                    (click)="removeClusterSector(clusterSector.clusterSector)"
                    class="
                      fusion-button
                      button-flat
                      fusion-button-default-size
                      button-default button-28
                      fusion-button-span-yes fusion-button-default-type
                    "
                    target="_self"
                    ><span class="fusion-button-text">Rimuovi</span></a
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 15px"
          ></div>
          <div
            *ngIf="
              clusterSector.errorMessage !== null &&
              clusterSector.errorMessage != undefined
            "
            class="ng-alert"
          >
            {{ clusterSector.errorMessage }}
          </div>
        </div>
      </div>
      </div>

      <!-- END CLUSTER SECTORS-->

      <!-- MINIMUM REQUIREMENTS-->
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"      ></div>

      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_2_3
          fusion-builder-nested-column-25
          fusion-two-third
          fusion-column-first
          2_3
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 66.66%;
          width: calc(66.66% - ((4%) * 0.6666));
          margin-right: 4%;
        "      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-25"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <p><strong>REQUISITI MINIMI</strong></p>
        </div>
      </div>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_3
          fusion-builder-nested-column-26
          fusion-one-third
          fusion-column-last
          1_3
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 33.33%;
          width: calc(33.33% - ((4%) * 0.3333));        "      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-26"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-28 {
                border-radius: 0px;
              }
            </style>
            <div *ngIf="canChangeTender">
              <a
                (click)="addMinimumRequirement()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-28
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text">Aggiungi</span></a
              >
            </div>
          </div>
        </div>
      </div>

      <div *ngFor="let minimumRequirement of minimumRequirements">
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 15px"
        ></div>
        <div class="specialization-container">
          <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
            <div
              class="
                fusion-layout-column
                fusion_builder_column
                fusion_builder_column_1_2
                fusion-builder-nested-column-11
                fusion-one-half
                fusion-column-first
                1_2
              "
              style="
                margin-top: 0px;
                margin-bottom: 0px;
                width: 50%;
                width: calc(50% - ((4%) * 0.5));
                margin-right: 4%;
              "
            >
              <div
                class="fusion-column-wrapper fusion-column-wrapper-11"
                style="
                  padding: 0px 0px 0px 0px;
                  background-position: left top;
                  background-repeat: no-repeat;
                  -webkit-background-size: cover;
                  -moz-background-size: cover;
                  -o-background-size: cover;
                  background-size: cover;
                "
                data-bg-url=""
              >
                <ul
                  class="fusion-checklist fusion-checklist-15"
                  style="font-size: 16px; line-height: 27.2px"
                >
                  <li class="fusion-li-item">
                    <div class="fusion-li-item-content">NOME*</div>
                  </li>
                </ul>
                <div class="fusion-button-wrapper fusion-align-block">
                  <style type="text/css">
                    .fusion-button.button-17 .fusion-button-text,
                    .fusion-button.button-17 i {
                      color: #333333;
                    }

                    .fusion-button.button-17 .fusion-button-icon-divider {
                      border-color: #333333;
                    }

                    .fusion-button.button-17:hover .fusion-button-text,
                    .fusion-button.button-17:hover i,
                    .fusion-button.button-17:focus .fusion-button-text,
                    .fusion-button.button-17:focus i,
                    .fusion-button.button-17:active .fusion-button-text,
                    .fusion-button.button-17:active {
                      color: #ffffff;
                    }

                    .fusion-button.button-17:hover .fusion-button-icon-divider,
                    .fusion-button.button-17:hover .fusion-button-icon-divider,
                    .fusion-button.button-17:active
                      .fusion-button-icon-divider {
                      border-color: #ffffff;
                    }

                    .fusion-button.button-17:hover,
                    .fusion-button.button-17:focus,
                    .fusion-button.button-17:active {
                      border-color: #ffffff;
                    }

                    .fusion-button.button-17 {
                      border-color: #333333;
                      border-radius: 0px;
                    }

                    .fusion-button.button-17 {
                      background: #ffffff;
                    }

                    .fusion-button.button-17:hover,
                    .button-17:focus,
                    .fusion-button.button-17:active {
                      background: #ffffff;
                    }
                  </style>
                  <input
                    class="manual-validation-valid"
                    class="ng-app-input"
                    type="text"
                    [(ngModel)]="minimumRequirement.minimumRequirement.name"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="
                      setMinimumRequirementName(minimumRequirement)
                    "
                    [disabled]="!canChangeTender"
                  />
                </div>
              </div>
            </div>
            <div
              class="
                fusion-layout-column
                fusion_builder_column
                fusion_builder_column_1_2
                fusion-builder-nested-column-12
                fusion-one-half
                fusion-column-last
                1_2
              "
              style="
                margin-top: 0px;
                margin-bottom: 0px;
                width: 50%;
                width: calc(50% - ((4%) * 0.5));
              "
            >
              <div
                class="fusion-column-wrapper fusion-column-wrapper-12"
                style="
                  padding: 0px 0px 0px 0px;
                  background-position: left top;
                  background-repeat: no-repeat;
                  -webkit-background-size: cover;
                  -moz-background-size: cover;
                  -o-background-size: cover;
                  background-size: cover;
                "
                data-bg-url=""
              >
                <ul
                  class="fusion-checklist fusion-checklist-16"
                  style="font-size: 16px; line-height: 27.2px"
                >
                  <li class="fusion-li-item">
                    <div class="fusion-li-item-content">VALORE*</div>
                  </li>
                </ul>
                <div class="fusion-button-wrapper fusion-align-block">
                  <style type="text/css">
                    .fusion-button.button-18 .fusion-button-text,
                    .fusion-button.button-18 i {
                      color: #333333;
                    }

                    .fusion-button.button-18 .fusion-button-icon-divider {
                      border-color: #333333;
                    }

                    .fusion-button.button-18:hover .fusion-button-text,
                    .fusion-button.button-18:hover i,
                    .fusion-button.button-18:focus .fusion-button-text,
                    .fusion-button.button-18:focus i,
                    .fusion-button.button-18:active .fusion-button-text,
                    .fusion-button.button-18:active {
                      color: #ffffff;
                    }

                    .fusion-button.button-18:hover .fusion-button-icon-divider,
                    .fusion-button.button-18:hover .fusion-button-icon-divider,
                    .fusion-button.button-18:active
                      .fusion-button-icon-divider {
                      border-color: #ffffff;
                    }

                    .fusion-button.button-18:hover,
                    .fusion-button.button-18:focus,
                    .fusion-button.button-18:active {
                      border-color: #ffffff;
                    }

                    .fusion-button.button-18 {
                      border-color: #333333;
                      border-radius: 0px;
                    }

                    .fusion-button.button-18 {
                      background: #ffffff;
                    }

                    .fusion-button.button-18:hover,
                    .button-18:focus,
                    .fusion-button.button-18:active {
                      background: #ffffff;
                    }
                  </style>
                  <input
                    class="manual-validation-valid"
                    class="ng-app-input"
                    type="text"
                    [(ngModel)]="minimumRequirement.minimumRequirement.value"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="!canChangeTender"
                  />
                  <!-- (ngModelChange)="setMinimumRequirementValue(minimumRequirement)" -->
                </div>
              </div>
            </div>
          </div>

          <style>
            a {
              color: #333333;
            }
            a:hover {
              color: var(--ng-app-theme-yellow-color);
            }
          </style>
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_4
              fusion-builder-nested-column-24
              fusion-one-fourth
              fusion-column-last
              1_4
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 23%;
              width: calc(23% - ((4% + 4%) * 0.25));
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-24"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              "
              data-bg-url=""
            >
              <div
                class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 40px"
              ></div>
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-28 {
                    border-radius: 0px;
                  }
                </style>
                <div *ngIf="canChangeTender">
                  <a
                    (click)="removeMinimumRequirement(minimumRequirement)"
                    class="
                      fusion-button
                      button-flat
                      fusion-button-default-size
                      button-default button-28
                      fusion-button-span-yes fusion-button-default-type
                    "
                    target="_self"
                    ><span class="fusion-button-text">Rimuovi</span></a
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 15px"
          ></div>
          <div
            *ngIf="
              minimumRequirement.errorMessage !== null &&
              minimumRequirement.errorMessage != undefined
            "
            class="ng-alert"
          >
            {{ minimumRequirement.errorMessage }}
          </div>
        </div>
      </div>
      <!-- /MINIMUM REQUIREMENTS -->

      

    <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>
      <!-- GARA PRIVATA / PUBBLICA -->
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"
      ></div>
      <p id="visibilitySection"><strong>VISIBILITA' GARA*</strong></p>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"
      ></div>
      <div
        class="fusion-builder-row fusion-builder-row-inner fusion-row"
        id="visibility"
      >
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-13
            fusion-one-half
            fusion-column-first
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-13"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-11"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <input
                  type="checkbox"
                  id="chVisibilityTrue"
                  formControlName="visibilityTrue"
                  class="yellowBorderedCheckbox"
                  (click)="setVisibility(true)"
                />
                <label for="chVisibilityTrue"
                  ><span></span>Pubblica</label
                >
              </li>
            </ul>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-14
            fusion-one-half
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-14"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-12"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <input
                  type="checkbox"
                  id="chVisibilityFalse"
                  formControlName="visibilityFalse"
                  class="yellowBorderedCheckbox"
                  (click)="setVisibility(false)"
                />
                <label for="chVisibilityFalse"
                  ><span></span>Privata</label
                >
              </li>
            </ul>
          </div>
        </div>
        <div
          [ngStyle]="{
            visibility: !errorVisibility ? 'hidden' : 'visible'
          }"
          class="ng-alert"
        >
          Scegliere un'opzione per la visibilità gara.
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>
      <!-- MAX APPLICATIONS (candidature spontanee massime) -->

      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_2_3
          fusion-builder-nested-column-25
          fusion-two-third
          fusion-column-first
          2_3
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 66.66%;
          width: calc(66.66% - ((4%) * 0.6666));
          margin-right: 4%;
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-25"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <p><strong>CANDIDATURE SPONTANEE</strong></p>
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-button-wrapper fusion-align-block">
        <style type="text/css">
          .fusion-button.button-1 .fusion-button-text,
          .fusion-button.button-1 i {
            color: #a5a5a5;
          }

          .fusion-button.button-1 .fusion-button-icon-divider {
            border-color: #a5a5a5;
          }

          .fusion-button.button-1:hover .fusion-button-text,
          .fusion-button.button-1:hover i,
          .fusion-button.button-1:focus .fusion-button-text,
          .fusion-button.button-1:focus i,
          .fusion-button.button-1:active .fusion-button-text,
          .fusion-button.button-1:active {
            color: #ffffff;
          }

          .fusion-button.button-1:hover .fusion-button-icon-divider,
          .fusion-button.button-1:hover .fusion-button-icon-divider,
          .fusion-button.button-1:active .fusion-button-icon-divider {
            border-color: #ffffff;
          }

          .fusion-button.button-1:hover,
          .fusion-button.button-1:focus,
          .fusion-button.button-1:active {
            border-color: #ffffff;
          }

          .fusion-button.button-1 {
            border-color: #333333;
            border-radius: 0px;
          }

          .fusion-button.button-1 {
            background: #ffffff;
          }

          .fusion-button.button-1:hover,
          .button-1:focus,
          .fusion-button.button-1:active {
            background: #ffffff;
          }
        </style>
        <ul
          class="fusion-checklist fusion-checklist-16"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <input
              type="checkbox"
              id="checkMaxApplications"
              formControlName="maxApplicationsCheck"
              class="yellowBorderedCheckbox"
              (click)="toggleMaxApplications()"
            />
            <!-- [(ngModel)]="showMaxApplications" -->
            <label for="checkMaxApplications"
              ><span></span>Imposta il numero massimo di candidature
              spontanee</label
            >
          </li>
        </ul>
      </div>
      <div *ngIf="showMaxApplications">
        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 20px"
        ></div>
        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 15px"
        ></div>
        <div
          class="fusion-builder-row fusion-builder-row-inner fusion-row"
          style="display: flex; flex-wrap: wrap"
        >
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-13
              fusion-one-half
              fusion-column-first
              1_2
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 50%;
              width: calc(50% - ((4% + 4%) * 0.5));
              margin-right: 4%;
              margin-bottom: 29px;
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-13"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              "
              data-bg-url=""
            >
              <ul
                class="fusion-checklist fusion-checklist-5"
                style="font-size: 16px; line-height: 27.2px"
              >
                <li class="fusion-li-item">
                  <span
                    style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                    class="icon-wrapper circle-no"
                    ><i
                      class="fusion-li-icon fa fa-id-card-alt"
                      style="color: #333333"
                    ></i
                  ></span>
                  <div
                    class="fusion-li-item-content"
                    style="margin-left: 38.4px"
                  >
                    LIMITE DI CANDIDATURE
                  </div>
                </li>
              </ul>
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-8 .fusion-button-text,
                  .fusion-button.button-8 i {
                    color: #333333;
                  }

                  .fusion-button.button-8 .fusion-button-icon-divider {
                    border-color: #333333;
                  }

                  .fusion-button.button-8:hover .fusion-button-text,
                  .fusion-button.button-8:hover i,
                  .fusion-button.button-8:focus .fusion-button-text,
                  .fusion-button.button-8:focus i,
                  .fusion-button.button-8:active .fusion-button-text,
                  .fusion-button.button-8:active {
                    color: #ffffff;
                  }

                  .fusion-button.button-8:hover .fusion-button-icon-divider,
                  .fusion-button.button-8:hover .fusion-button-icon-divider,
                  .fusion-button.button-8:active .fusion-button-icon-divider {
                    border-color: #ffffff;
                  }

                  .fusion-button.button-8:hover,
                  .fusion-button.button-8:focus,
                  .fusion-button.button-8:active {
                    border-color: #ffffff;
                  }

                  .fusion-button.button-8 {
                    border-color: #333333;
                    border-radius: 0px;
                  }

                  .fusion-button.button-8 {
                    background: #ffffff;
                  }

                  .fusion-button.button-8:hover,
                  .button-8:focus,
                  .fusion-button.button-8:active {
                    background: #ffffff;
                  }
                </style>
                <input
                  class="ng-app-input"
                  type="number"
                  id="inputMaxApplications"
                  formControlName="inputMaxApplications"
                  (ngModelChange)="setMaxApplication()"
                />
                <!-- (click)="resetError()" -->
                <!-- [(ngModel)]="maxApplications" -->
                <div
                  [ngStyle]="{
                    visibility:
                      tenderForm.get('inputMaxApplications').valid ||
                      tenderForm.get('inputMaxApplications').pristine
                        ? 'hidden'
                        : 'visible'
                  }"
                  class="ng-alert"
                >
                  Inserire il limite di candidature spontanee.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- /MAX APPLICATIONS (candidature spontanee massime) -->

      <br />
      <br />

      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"
      ></div>
      <p id="qualificationsSection"><strong>TITOLI ABILITATIVI*</strong></p>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"
      ></div>
      <div
        class="fusion-builder-row fusion-builder-row-inner fusion-row"
        id="qualifications"
      >
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-13
            fusion-one-half
            fusion-column-first
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-13"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-11"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <input
                  type="checkbox"
                  id="chQualificationsTrue"
                  formControlName="qualificationsTrue"
                  class="yellowBorderedCheckbox"
                  (click)="setQualification(true)"
                />
                <label for="chQualificationsTrue"
                  ><span></span>Già ottenuti</label
                >
              </li>
            </ul>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-14
            fusion-one-half
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-14"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-12"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <input
                  type="checkbox"
                  id="chQualificationsFalse"
                  formControlName="qualificationsFalse"
                  class="yellowBorderedCheckbox"
                  (click)="setQualification(false)"
                />
                <label for="chQualificationsFalse"
                  ><span></span>In fase di ottenimento</label
                >
              </li>
            </ul>
          </div>
        </div>
        <div
          [ngStyle]="{
            visibility: !errorQualifications ? 'hidden' : 'visible'
          }"
          class="ng-alert"
        >
          Scegliere un'opzione per i titoli abilitativi.
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>

      <p id="qualificationsSection">
        <strong>TEMPO MASSIMO FORMULAZIONE OFFERTA</strong>
      </p>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"
      ></div>
      <div
        class="fusion-builder-row fusion-builder-row-inner fusion-row"
        id="qualifications"
      >
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-13
            fusion-one-half
            fusion-column-first
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-13"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-11"
              style="font-size: 16px; line-height: 27.2px"
            >
              Entro le ore<br />
              <select
                formControlName="maximumEstimateHour"
                id="maximumEstimateHour"
                (click)="resetError()"
              >
                <option [ngValue]="null"></option>
                <option [ngValue]="hour" *ngFor="let hour of hours">
                  {{ hour }}
                </option>
              </select>
            </ul>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-14
            fusion-one-half
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-14"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-11"
              style="font-size: 16px; line-height: 27.2px"
            >
              Del
              <br />
              <div
                class="fusion-button button-flat fusion-button-default-size button-custom button-9 fusion-button-span-yes fusion-button-default-type {{
                  maximumEstimateDateAlert
                }}"
              >
                <span
                  class="fusion-button-icon-divider button-icon-divider-left"
                  (click)="maximumEstimateDatePicker.open()"
                  ><i
                    class="fa-calendar-alt fas"
                    style="color: #c4c4c4 !important"
                  ></i
                ></span>
                <input
                  matInput
                  [matDatepicker]="maximumEstimateDatePicker"
                  placeholder="Data"
                  formControlName="maximumEstimateDate"
                  id="maximumEstimateDate"
                  style="
                    border-bottom: none !important;
                    padding-left: 30px !important;
                    padding-bottom: 3px !important;
                    padding-top: 3px !important;
                  "
                />
                <mat-datepicker #maximumEstimateDatePicker></mat-datepicker>
              </div>
            </ul>
          </div>
        </div>
        <div
          [ngStyle]="{
            visibility:
              tenderForm.get('maximumEstimateDate').valid ||
              tenderForm.get('maximumEstimateDate').pristine
                ? 'hidden'
                : 'visible'
          }"
          class="ng-alert"
        >
          Scegliere una data massima per il preventivo.
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>
      <p><strong>SUBAPPALTO*</strong></p>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"
      ></div>
      <div
        class="fusion-builder-row fusion-builder-row-inner fusion-row"
        id="subcontract"
      >
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-15
            fusion-one-half
            fusion-column-first
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-15"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-13"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <input
                  type="checkbox"
                  id="chSubcontractTrue"
                  formControlName="subcontractTrue"
                  class="yellowBorderedCheckbox"
                  (click)="setSubcontract(true)"
                />
                <label for="chSubcontractTrue"
                  ><span></span>Gara condotta a finalità Subappalto</label
                >
              </li>
            </ul>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-16
            fusion-one-half
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-16"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-14"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <input
                  type="checkbox"
                  id="chSubcontractFalse"
                  formControlName="subcontractFalse"
                  class="yellowBorderedCheckbox"
                  (click)="setSubcontract(false)"
                />
                <label for="chSubcontractFalse"
                  ><span></span>Non è un Subappalto</label
                >
              </li>
            </ul>
          </div>
        </div>
        <div
          [ngStyle]="{ visibility: !errorSubcontract ? 'hidden' : 'visible' }"
          class="ng-alert"
        >
          Scegliere un'opzione per il subappalto.
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>
      <p><strong>MIGLIORE OFFERTA*</strong></p>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"
      ></div>
      <div
        class="fusion-builder-row fusion-builder-row-inner fusion-row"
        id="showBestOffer"
      >
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-17
            fusion-one-half
            fusion-column-first
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-17"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-15"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <input
                  type="checkbox"
                  id="chShowBestOfferTrue"
                  formControlName="showBestOfferTrue"
                  class="yellowBorderedCheckbox"
                  (click)="setShowBestOffer(true)"
                />
                <label for="chShowBestOfferTrue"
                  ><span></span>Mostra la migliore offerta ricevuta</label
                >
              </li>
            </ul>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-18
            fusion-one-half
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-18"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <ul
              class="fusion-checklist fusion-checklist-16"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <input
                  type="checkbox"
                  id="chShowBestOfferFalse"
                  formControlName="showBestOfferFalse"
                  class="yellowBorderedCheckbox"
                  (click)="setShowBestOffer(false)"
                />
                <label for="chShowBestOfferFalse"
                  ><span></span>Informazione Riservata</label
                >
              </li>
            </ul>
          </div>
        </div>
        <div
          [ngStyle]="{ visibility: !errorShowBestOffer ? 'hidden' : 'visible' }"
          class="ng-alert"
        >
          Scegliere un'opzione per la migliore offerta.
        </div>
      </div>

      <div *ngIf="canChangeTender || attachments.length > 0">
        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 0px"
        ></div>
        <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-19
              fusion-one-half
              fusion-column-first
              1_2
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 50%;
              width: calc(50% - ((4%) * 0.5));
              margin-right: 4%;
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-19"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              "
              data-bg-url=""
            >
              <div class="fusion-text">
                <p style="margin-top: 5px"><strong>ALLEGATI</strong></p>
              </div>
            </div>
          </div>
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-20
              fusion-one-half
              fusion-column-last
              1_2
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 50%;
              width: calc(50% - ((4%) * 0.5));
            "
          ></div>
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div *ngFor="let attachment of attachments">
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-21
              fusion-three-fourth
              fusion-column-first
              1_2
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 50%;
              width: calc(50% - ((4%) * 0.5));
              margin-right: 4%;
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-21"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              "
              data-bg-url=""
            >
              <div class="fusion-text" style="font-size: 15px; margin-top: 0px">
                <p
                  style="
                    margin-bottom: 0px !important;
                    color: #333333;
                    font-weight: 400;
                  "
                >
                  {{ getDocumentTypeDescription(attachment) }} &#8211;
                  {{ attachment.fileName }}
                </p>
                <div>
                  <input
                    type="checkbox"
                    class="yellowBorderedCheckbox"
                    id="chShowAttachment-{{ attachment.fileName }}"
                    [(ngModel)]="attachment.publiclyVisible"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="!canChangeTender"
                  />
                  <label
                    for="chShowAttachment-{{ attachment.fileName }}"
                    style="color: #606060"
                    ><span></span>Visibile pubblicamente.</label
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-22
              fusion-one-fourth
              fusion-column-last
              1_2
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 50%;
              width: calc(50% - ((4%) * 0.5));
            "
          >
            <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
              <div
                class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_2
                  fusion-builder-nested-column-21
                  fusion-one-fourth
                  fusion-column-last
                  1_2
                "
                style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 50%;
                  width: calc(50% - ((1%) * 0.5));
                "
              >
                <div
                  class="fusion-column-wrapper fusion-column-wrapper-22"
                  style="
                    padding: 0px 0px 0px 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                    margin-right: 4%;
                  "
                  data-bg-url=""
                >
                  <div class="fusion-button-wrapper fusion-align-block">
                    <style type="text/css">
                      .fusion-button.button-10 {
                        border-radius: 0px;
                      }
                    </style>
                    <a
                      (click)="deleteAttachment(attachment)"
                      [ngStyle]="{
                        visibility: canChangeTender ? 'visible' : 'hidden'
                      }"
                      class="
                        fusion-button
                        button-flat
                        fusion-button-default-size
                        button-default button-10
                        fusion-button-span-yes fusion-button-default-type
                      "
                      target="_self"
                      ><span
                        class="
                          fusion-button-icon-divider
                          button-icon-divider-left
                        "
                        ><i class="fa-trash-alt fas"></i></span
                      ><span class="fusion-button-text fusion-button-text-left"
                        >RIMUOVI</span
                      ></a
                    >
                  </div>
                </div>
              </div>
              <div
                class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_2
                  fusion-builder-nested-column-22
                  fusion-one-fourth
                  fusion-column-last
                  1_2
                "
                style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 50%;
                  width: calc(50% - ((1%) * 0.5));
                "
              >
                <div
                  class="fusion-column-wrapper fusion-column-wrapper-22"
                  style="
                    padding: 0px 0px 0px 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                    margin-left: 4%;
                  "
                  data-bg-url=""
                >
                  <div class="fusion-button-wrapper fusion-align-block">
                    <style type="text/css">
                      .fusion-button.button-10 {
                        border-radius: 0px;
                      }
                    </style>
                    <a
                      (click)="openAttachment(attachment, null)"
                      class="fusion-button button-flat fusion-button-default-size button-default{{
                        getDownloadButtonStyle(attachment)
                      }} button-10 fusion-button-span-yes fusion-button-default-type"
                      target="_self"
                      ><span
                        class="
                          fusion-button-icon-divider
                          button-icon-divider-left
                        "
                        ><i class="fa-save fas"></i></span
                      ><span class="fusion-button-text fusion-button-text-left"
                        >SCARICA</span
                      ></a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fusion-sep-clear"></div>
          <div
            class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 10px"
          ></div>
        </div>
      </div>

      <div *ngIf="canChangeTender">
        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 20px"
        ></div>
        <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_3
              fusion-builder-nested-column-27
              fusion-one-third
              fusion-column-first
              1_3
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 33.33%;
              width: calc(33.33% - ((4% + 4%) * 0.3333));
              margin-right: 4%;
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-27"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                margin-top: 4px;
              "
              data-bg-url=""
            >
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-13 {
                    border-radius: 0px;
                  }
                </style>
                <input
                  style="display: none"
                  type="file"
                  (change)="uploadAttachment('IMAGE', $event)"
                  #uploadImageInput
                />
                <a
                  (click)="uploadImageInputClick()"
                  class="
                    fusion-button
                    button-flat
                    fusion-button-default-size
                    button-default button-13
                    fusion-button-span-yes fusion-button-default-type
                  "
                  target="_self"
                  ><span class="fusion-button-text">Carica Foto</span></a
                >
              </div>
            </div>
          </div>
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_3
              fusion-builder-nested-column-28
              fusion-one-third
              1_3
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 33.33%;
              width: calc(33.33% - ((4% + 4%) * 0.3333));
              margin-right: 4%;
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-28"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                margin-top: 4px;
              "
              data-bg-url=""
            >
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-14 {
                    border-radius: 0px;
                  }
                </style>
                <input
                  style="display: none"
                  type="file"
                  (change)="uploadAttachment('DRAWING', $event)"
                  #uploadDrawingInput
                />
                <a
                  (click)="uploadDrawingInputClick()"
                  class="
                    fusion-button
                    button-flat
                    fusion-button-default-size
                    button-default button-14
                    fusion-button-span-yes fusion-button-default-type
                  "
                  target="_self"
                  ><span class="fusion-button-text">Carica Disegni</span></a
                >
              </div>
            </div>
          </div>
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_3
              fusion-builder-nested-column-29
              fusion-one-third
              fusion-column-last
              1_3
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 33.33%;
              width: calc(33.33% - ((4% + 4%) * 0.3333));
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-29"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                margin-top: 4px;
              "
              data-bg-url=""
            >
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-15 {
                    border-radius: 0px;
                  }
                </style>
                <input
                  style="display: none"
                  type="file"
                  (change)="uploadAttachment('OTHER', $event)"
                  #uploadOtherInput
                />
                <a
                  (click)="uploadOtherInputClick()"
                  class="
                    fusion-button
                    button-flat
                    fusion-button-default-size
                    button-default button-15
                    fusion-button-span-yes fusion-button-default-type
                  "
                  target="_self"
                  ><span class="fusion-button-text">Carica Altro</span></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div
        *ngIf="canChangeTender || attachments.length > 0"
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 30px"
      ></div>
      <!-- METRIC CALCULATION vs DETAIL LIST SELECTOR -->
      <div *ngIf="loadedTender.tenderType !== 'PRIVATE'">
        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          id="requestDataEntryTypeSection"
          style="margin-left: auto; margin-right: auto; margin-top: 20px"
        ></div>
        <p><strong>MODALIT&Agrave; DI COMPILAZIONE*</strong></p>
        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 0px"
        ></div>
        <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-17
              fusion-one-half
              fusion-column-first
              1_2
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 50%;
              width: calc(50% - ((4%) * 0.5));
              margin-right: 4%;
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-17"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              "
              data-bg-url=""
            >
              <ul
                class="fusion-checklist fusion-checklist-15"
                style="font-size: 16px; line-height: 27.2px"
              >
                <li class="fusion-li-item">
                  <input
                    type="checkbox"
                    id="chMetricCalculation"
                    formControlName="requestDataEntryTypeMetricCalculation"
                    class="yellowBorderedCheckbox"
                    (click)="setRequestDataEntryType('METRIC_CALCULATION')"
                  />
                  <label for="chMetricCalculation"
                    ><span></span>Computo Metrico</label
                  >
                </li>
              </ul>
            </div>
          </div>
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-18
              fusion-one-half
              fusion-column-last
              1_2
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 50%;
              width: calc(50% - ((4%) * 0.5));
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-18"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              "
              data-bg-url=""
            >
              <ul
                class="fusion-checklist fusion-checklist-16"
                style="font-size: 16px; line-height: 27.2px"
              >
                <li class="fusion-li-item">
                  <input
                    type="checkbox"
                    id="chDetailList"
                    formControlName="requestDataEntryTypeDetailList"
                    class="yellowBorderedCheckbox"
                    (click)="setRequestDataEntryType('DETAIL_LIST')"
                  />
                  <label for="chDetailList"><span></span>Elenco Dettagli</label>
                </li>
              </ul>
            </div>
          </div>
          <div
            [ngStyle]="{
              visibility: !errorRequestDataEntryType ? 'hidden' : 'visible'
            }"
            class="ng-alert"
          >
            Scegliere un'opzione per la modalità di compilazione.
          </div>
        </div>
        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 40px"
        ></div>
      </div>
      <!-- METRIC CALCULATION vs DETAIL LIST SELECTOR - END -->
      <!-- DETAIL LIST -->
      <div
        *ngIf="tenderForm.get('requestDataEntryTypeDetailList').value === true"
      >
        <div *ngIf="loadedTender.tenderType === 'PRIVATE'">
          <div
            class="fusion-separator fusion-full-width-sep sep-none"
            id="requestDataEntryTypeSection"
            style="margin-left: auto; margin-right: auto; margin-top: 20px"
          ></div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_2_3
            fusion-builder-nested-column-25
            fusion-two-third
            fusion-column-first
            2_3
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 66.66%;
            width: calc(66.66% - ((4%) * 0.6666));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-25"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <p><strong>ELENCO DETTAGLI</strong></p>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_3
            fusion-builder-nested-column-26
            fusion-one-third
            fusion-column-last
            1_3
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 33.33%;
            width: calc(33.33% - ((4%) * 0.3333));
          "
          [ngStyle]="{ visibility: !canChangeTender ? 'hidden' : 'visible' }"
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-26"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-28 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="addRequestDetail()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-28
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text">Aggiungi dettaglio</span></a
              >
            </div>
          </div>
        </div>
        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 10px"
        ></div>
        <div *ngFor="let requestDetail of requestDetails">
          <div
            style="
              padding: 3%;
              background-color: var(--ng-app-input-text-color);
              margin-bottom: 2%;
            "
          >
            <ul
              class="fusion-checklist fusion-checklist-2"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <span
                  style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                  class="icon-wrapper circle-no"
                  ><i
                    class="fusion-li-icon fa-align-center fas"
                    style="color: #333333"
                  ></i
                ></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  <p>BREVE DESCRIZIONE*</p>
                </div>
              </li>
            </ul>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-2 .fusion-button-text,
                .fusion-button.button-2 i {
                  color: #a5a5a5;
                }

                .fusion-button.button-2 .fusion-button-icon-divider {
                  border-color: #a5a5a5;
                }

                .fusion-button.button-2:hover .fusion-button-text,
                .fusion-button.button-2:hover i,
                .fusion-button.button-2:focus .fusion-button-text,
                .fusion-button.button-2:focus i,
                .fusion-button.button-2:active .fusion-button-text,
                .fusion-button.button-2:active {
                  color: #ffffff;
                }

                .fusion-button.button-2:hover .fusion-button-icon-divider,
                .fusion-button.button-2:hover .fusion-button-icon-divider,
                .fusion-button.button-2:active .fusion-button-icon-divider {
                  border-color: #ffffff;
                }

                .fusion-button.button-2:hover,
                .fusion-button.button-2:focus,
                .fusion-button.button-2:active {
                  border-color: #ffffff;
                }

                .fusion-button.button-2 {
                  border-color: #333333;
                  border-radius: 0px;
                }

                .fusion-button.button-2 {
                  background: #ffffff;
                }

                .fusion-button.button-2:hover,
                .button-2:focus,
                .fusion-button.button-2:active {
                  background: #ffffff;
                }
              </style>
              <textarea
                type="text"
                placeholder="Descrizione"
                [(ngModel)]="requestDetail.description"
                [ngModelOptions]="{ standalone: true }"
                maxlength="500"
                [disabled]="!canChangeTender"
              ></textarea>
            </div>
            <div class="fusion-sep-clear"></div>
            <div
              class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 30px"
            ></div>

            <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
              <div
                class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_3
                  fusion-builder-nested-column-32
                  fusion-one-third
                  fusion-column-first
                  1_3
                "
                style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 33.33%;
                  width: calc(33.33% - ((4% + 4%) * 0.3333));
                  margin-right: 4%;
                "
              >
                <div
                  class="fusion-column-wrapper fusion-column-wrapper-32"
                  style="
                    padding: 0px 0px 0px 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                  "
                  data-bg-url=""
                >
                  <ul
                    class="fusion-checklist fusion-checklist-2"
                    style="font-size: 16px; line-height: 27.2px"
                  >
                    <li class="fusion-li-item">
                      <span
                        style="
                          height: 27.2px;
                          width: 27.2px;
                          margin-right: 11.2px;
                        "
                        class="icon-wrapper circle-no"
                        ><i
                          class="fusion-li-icon fa-ruler fas"
                          style="color: #333333"
                        ></i
                      ></span>
                      <div
                        class="fusion-li-item-content"
                        style="margin-left: 38.4px"
                      >
                        <p>UNIT&Agrave; DI MISURA*</p>
                      </div>
                    </li>
                  </ul>
                  <div class="fusion-button-wrapper fusion-align-block">
                    <style type="text/css">
                      .fusion-button.button-8 .fusion-button-text,
                      .fusion-button.button-8 i {
                        color: #333333;
                      }

                      .fusion-button.button-8 .fusion-button-icon-divider {
                        border-color: #333333;
                      }

                      .fusion-button.button-8:hover .fusion-button-text,
                      .fusion-button.button-8:hover i,
                      .fusion-button.button-8:focus .fusion-button-text,
                      .fusion-button.button-8:focus i,
                      .fusion-button.button-8:active .fusion-button-text,
                      .fusion-button.button-8:active {
                        color: #ffffff;
                      }

                      .fusion-button.button-8:hover .fusion-button-icon-divider,
                      .fusion-button.button-8:hover .fusion-button-icon-divider,
                      .fusion-button.button-8:active
                        .fusion-button-icon-divider {
                        border-color: #ffffff;
                      }

                      .fusion-button.button-8:hover,
                      .fusion-button.button-8:focus,
                      .fusion-button.button-8:active {
                        border-color: #ffffff;
                      }

                      .fusion-button.button-8 {
                        border-color: #333333;
                        border-radius: 0px;
                      }

                      .fusion-button.button-8 {
                        background: #ffffff;
                      }

                      .fusion-button.button-8:hover,
                      .button-8:focus,
                      .fusion-button.button-8:active {
                        background: #ffffff;
                      }
                    </style>
                    <select
                      [(ngModel)]="requestDetail.unitOfMeasureCode"
                      [ngModelOptions]="{ standalone: true }"
                      [disabled]="!canChangeTender"
                    >
                      <option [ngValue]="null"></option>
                      <option
                        [ngValue]="unitOfMeasure.code"
                        *ngFor="let unitOfMeasure of unitOfMeasureList"
                      >
                        {{ unitOfMeasure.description }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_3
                  fusion-builder-nested-column-33
                  fusion-one-third
                  1_3
                "
                style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 33.33%;
                  width: calc(33.33% - ((4% + 4%) * 0.3333));
                  margin-right: 4%;
                "
              >
                <ul
                  class="fusion-checklist fusion-checklist-2"
                  style="font-size: 16px; line-height: 27.2px"
                >
                  <li class="fusion-li-item">
                    <span
                      style="
                        height: 27.2px;
                        width: 27.2px;
                        margin-right: 11.2px;
                      "
                      class="icon-wrapper circle-no"
                      ><i
                        class="fusion-li-icon fa-list-ol fas"
                        style="color: #333333"
                      ></i
                    ></span>
                    <div
                      class="fusion-li-item-content"
                      style="margin-left: 38.4px"
                    >
                      <p>QUANTIT&Agrave;</p>
                    </div>
                  </li>
                </ul>
                <div
                  class="fusion-column-wrapper fusion-column-wrapper-33"
                  style="
                    padding: 0px 0px 0px 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                  "
                  data-bg-url=""
                >
                  <div class="fusion-button-wrapper fusion-align-block">
                    <input
                      type="text"
                      placeholder="Quantità"
                      [(ngModel)]="requestDetail.amount"
                      [ngModelOptions]="{ standalone: true }"
                      [disabled]="!canChangeTender"
                    />
                  </div>
                </div>
              </div>
              <div
                class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_3
                  fusion-builder-nested-column-34
                  fusion-one-third
                  fusion-column-last
                  1_3
                "
                style="
                  margin-top: 46px;
                  margin-bottom: 0px;
                  width: 33.33%;
                  width: calc(33.33% - ((4% + 4%) * 0.3333));
                "
                [ngStyle]="{
                  visibility: !canChangeTender ? 'hidden' : 'visible'
                }"
              >
                <div
                  class="fusion-column-wrapper fusion-column-wrapper-34"
                  style="
                    padding: 0px 0px 0px 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                  "
                  data-bg-url=""
                >
                  <div class="fusion-button-wrapper fusion-align-block">
                    <style type="text/css">
                      .fusion-button.button-28 {
                        border-radius: 0px;
                      }
                    </style>
                    <a
                      (click)="deleteReQuestDetail(requestDetail)"
                      class="
                        fusion-button
                        button-flat
                        fusion-button-default-size
                        button-default button-28
                        fusion-button-span-yes fusion-button-default-type
                      "
                      target="_self"
                      ><span class="fusion-button-text">Cancella</span></a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          [ngStyle]="{
            visibility: detailListError === 'no_error' ? 'hidden' : 'visible'
          }"
          class="ng-alert"
        >
          {{ detailListError }}
        </div>

        <div
          class="update-container"
          *ngIf="
            loadedTender.tenderType === 'PRIVATE' &&
            loadedTender.tenderStatus === 'DRAFT'
          "
        >
          <div class="update-container update-container-inner">
            <h3>
              &Egrave; possibile effettuare un upgrade da gara comittenti a gara
              professionisti.
            </h3>
            <div class="upgrade-btn-container">
              <a
                (click)="upgradeTender()"
                style="margin-right: 2%"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-28
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text">Fai upgrade</span></a
              >
              <a
                (click)="infoUpgrateTenderModal.open()"
                style="margin-left: 2%"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-28
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text">Scopri i vantaggi</span></a
              >
            </div>
          </div>
        </div>
      </div>
      <!-- DETAIL LIST - END -->
      <!-- METRIC CALCULATION -->
      <div
        *ngIf="
          tenderForm.get('requestDataEntryTypeMetricCalculation').value === true
        "
      >
        <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-30
              fusion-one-half
              fusion-column-first
              1_2
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 50%;
              width: calc(50% - ((4%) * 0.5));
              margin-right: 4%;
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-30"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              "
              data-bg-url=""
            >
              <div class="fusion-text">
                <p style="margin-top: 5px"><strong>COMPUTO METRICO</strong></p>
              </div>
            </div>
          </div>
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-31
              fusion-one-half
              fusion-column-last
              1_2
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 50%;
              width: calc(50% - ((4%) * 0.5));
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-31"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              "
              data-bg-url=""
            >
              <ul
                class="fusion-checklist fusion-checklist-18"
                style="font-size: 16px; line-height: 27.2px"
              >
                <li class="fusion-li-item">
                  <input
                    type="checkbox"
                    id="chShowMetricCalculation"
                    formControlName="showMetricCalculation"
                    class="yellowBorderedCheckbox"
                    ng-disabled="!canChangeTender"
                  />
                  <label for="chShowMetricCalculation"
                    ><span></span>Visibile pubblicamente</label
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          class="fusion-builder-row fusion-builder-row-inner fusion-row"
          *ngIf="canChangeTender"
        >
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_3
              fusion-builder-nested-column-32
              fusion-one-third
              fusion-column-first
              1_3
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 33.33%;
              width: calc(33.33% - ((4% + 4%) * 0.3333));
              margin-right: 4%;
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-32"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                margin-top: 4px;
              "
              data-bg-url=""
            >
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-16 {
                    border-radius: 0px;
                  }
                </style>
                <a
                  (click)="openAttachment(metricCalculationTemplate, null)"
                  class="fusion-button button-flat fusion-button-default-size button-default{{
                    getDownloadButtonStyle(metricCalculationTemplate)
                  }} fusion-button-span-yes fusion-button-default-type"
                  target="_self"
                  ><span class="fusion-button-text">Scarica Template</span></a
                >
              </div>
            </div>
          </div>
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_3
              fusion-builder-nested-column-33
              fusion-one-third
              1_3
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 33.33%;
              width: calc(33.33% - ((4% + 4%) * 0.3333));
              margin-right: 4%;
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-33"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                margin-top: 4px;
              "
              data-bg-url=""
            >
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-17 {
                    border-radius: 0px;
                  }
                </style>
                <input
                  style="display: none"
                  type="file"
                  (change)="uploadAttachment(null, $event)"
                  #uploadMetricCalculationDocInput
                />
                <a
                  *ngIf="!metricCalculationDoc"
                  (click)="uploadMetricCalculationDocInput.click()"
                  class="
                    fusion-button
                    button-flat
                    fusion-button-default-size
                    button-default
                    fusion-button-span-yes fusion-button-default-type
                  "
                  target="_self"
                  ><span class="fusion-button-text">Carica Computo</span></a
                >
                <a
                  *ngIf="metricCalculationDoc"
                  (click)="metricCalculationModal.open()"
                  class="
                    fusion-button
                    button-flat
                    fusion-button-default-size
                    button-default
                    fusion-button-span-yes fusion-button-default-type
                  "
                  target="_self"
                  ><span class="fusion-button-text">Carica Computo</span></a
                >
              </div>
            </div>
          </div>
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_3
              fusion-builder-nested-column-331
              fusion-one-third
              fusion-column-last
              1_3
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 33.33%;
              width: calc(33.33% - ((4% + 4%) * 0.3333));
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-331"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                margin-top: 4px;
              "
              data-bg-url=""
            >
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-17 {
                    border-radius: 0px;
                  }
                </style>
                <a
                  (click)="openAttachment(metricCalculationDoc, null)"
                  class="fusion-button button-flat fusion-button-default-size button-default{{
                    getDownloadButtonStyle(metricCalculationDoc)
                  }} fusion-button-span-yes fusion-button-default-type"
                  target="_self"
                  ><span class="fusion-button-text">Scarica Computo</span></a
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="fusion-builder-row fusion-builder-row-inner fusion-row"
          *ngIf="canChangeTender"
        >
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_3
              fusion-builder-nested-column-32
              fusion-one-third
              fusion-column-first
              1_3
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 33.33%;
              width: calc(33.33% - ((4% + 4%) * 0.3333));
              margin-right: 4%;
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-32"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                margin-top: 4px;
              "
              data-bg-url=""
            >
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-16 {
                    border-radius: 0px;
                  }
                </style>
              </div>
            </div>
          </div>
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_3
              fusion-builder-nested-column-33
              fusion-one-third
              1_3
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 33.33%;
              width: calc(33.33% - ((4% + 4%) * 0.3333));
              margin-right: 4%;
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-33"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                margin-top: 4px;
              "
              data-bg-url=""
            >
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-17 {
                    border-radius: 0px;
                  }
                </style>
                <a
                  (click)="openAttachment(metricCalculationInstruction, null)"
                  class="
                    fusion-button
                    button-flat
                    fusion-button-default-size
                    button-default
                    fusion-button-span-yes fusion-button-default-type
                  "
                  target="_self"
                  ><span class="fusion-button-text">Scarica Istruzioni</span></a
                >
              </div>
            </div>
          </div>
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_3
              fusion-builder-nested-column-331
              fusion-one-third
              fusion-column-last
              1_3
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 33.33%;
              width: calc(33.33% - ((4% + 4%) * 0.3333));
            "
          >
            <div
              *ngIf="
                metricCalculationDoc && loadedTender.tenderStatus === 'DRAFT'
              "
              class="fusion-column-wrapper fusion-column-wrapper-33"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                margin-top: 4px;
              "
              data-bg-url=""
            >
              <div class="fusion-button-wrapper fusion-align-block">
                <style type="text/css">
                  .fusion-button.button-17 {
                    border-radius: 0px;
                  }
                </style>
                <a
                  (click)="verifyMetricCalculation()"
                  class="
                    fusion-button
                    button-flat
                    fusion-button-default-size
                    button-default
                    fusion-button-span-yes fusion-button-default-type
                  "
                  target="_self"
                  ><span class="fusion-button-text">Verifica Computo</span></a
                >
              </div>
            </div>
          </div>
        </div>
        <div
          [ngStyle]="{
            visibility: !errorMetricCalculationDoc ? 'hidden' : 'visible'
          }"
          class="ng-{{ metricComputationMsgClass }}"
        >
          {{ metricComputationMsg }}
        </div>

        <div
          class="fusion-builder-row fusion-builder-row-inner fusion-row"
          *ngIf="!canChangeTender"
        >
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-34
              fusion-one-half
              fusion-column-first
              1_2
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 50%;
              width: calc(50% - ((4%) * 0.5));
              margin-right: 4%;
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-34"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                margin-top: 4px;
              "
              data-bg-url=""
            >
              <div class="fusion-button-wrapper fusion-aligncenter">
                <style type="text/css">
                  .fusion-button.button-18 {
                    border-radius: 0px;
                  }
                </style>
                <a
                  (click)="openAttachment(metricCalculationTemplate, null)"
                  class="fusion-button button-flat fusion-button-default-size button-default{{
                    getDownloadButtonStyle(metricCalculationTemplate)
                  }} fusion-button-span-yes fusion-button-default-type"
                  target="_self"
                  ><span class="fusion-button-text">Scarica Template</span></a
                >
              </div>
            </div>
          </div>
          <div
            class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_1_2
              fusion-builder-nested-column-35
              fusion-one-half
              fusion-column-last
              1_2
            "
            style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 50%;
              width: calc(50% - ((4%) * 0.5));
            "
          >
            <div
              class="fusion-column-wrapper fusion-column-wrapper-35"
              style="
                padding: 0px 0px 0px 0px;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                margin-top: 4px;
              "
              data-bg-url=""
            >
              <div class="fusion-button-wrapper fusion-aligncenter">
                <style type="text/css">
                  .fusion-button.button-19 {
                    border-radius: 0px;
                  }
                </style>
                <a
                  (click)="openAttachment(metricCalculationDoc, null)"
                  class="fusion-button button-flat fusion-button-default-size button-default{{
                    getDownloadButtonStyle(metricCalculationDoc)
                  }} fusion-button-span-yes fusion-button-default-type"
                  target="_self"
                  ><span class="fusion-button-text">Scarica Computo</span></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- METRIC CALCULATION - END -->
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 60px"
      ></div>
      <p style="margin-bottom: 0"><strong>INVITI</strong></p>

      <div *ngIf="tenderInvitations == null && tenderInvitations == undefined">
        <div class="fusion-text" style="font-size: 17px; font-style: italic">
          Non hai ancora invitato nessuno
        </div>
      </div>
      <div *ngIf="tenderInvitations != null && tenderInvitations != undefined">
        <ul
          class="fusion-checklist fusion-checklist-1"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li
            class="fusion-li-item"
            *ngFor="let invitation of tenderInvitations"
          >
            <span
              style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
              class="icon-wrapper circle-no"
              ><i
                class="fusion-li-icon fa-building fas"
                style="color: #333333"
              ></i
            ></span>
            <div class="fusion-li-item-content" style="margin-left: 38.4px">
              {{ invitation.customerName }} (Stato:
              {{ invitation.status == "ACCEPTED" ? "Accettato" : "In Attesa" }})
            </div>
          </li>
        </ul>
      </div>

      <div *ngIf="!canChangeTender">
        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 60px"
        ></div>
        <p style="margin-bottom: 0"><strong>PARTECIPANTI</strong></p>
        <div
          class="fusion-text"
          style="font-size: 17px; font-style: italic"
          *ngIf="publishedParticipations.length === 0"
        >
          In questa sezione verranno mostrati i partecipanti alla gara, non
          appena ce ne saranno.
        </div>
        <div
          class="fusion-text"
          style="font-size: 17px; font-style: italic"
          *ngIf="publishedParticipations.length > 0"
        >
          Seleziona con un click le offerte che vuoi portare avanti nella gara.
        </div>
        <div
          class="fusion-text"
          style="font-size: 17px; font-style: italic"
          *ngIf="loadedTender.tenderStatus === 'DEAL'"
        >
          Seleziona con un click l'offerta che vincerà la gara.
        </div>
        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 20px"
        ></div>

        <div *ngFor="let participation of publishedParticipations">
          <div
            (click)="selectParticipation(participation)"
            class="fusion-builder-row fusion-builder-row-inner fusion-row {{
              participation.selectedClass
            }}"
            style="
              background-color: var(--ng-app-light-grey-color);
              padding: 15px 15px 0px 15px;
            "
          >
            <div
              class="
                fusion-layout-column
                fusion_builder_column
                fusion_builder_column_1_2
                fusion-builder-nested-column-11
                fusion-one-half
                fusion-column-first
                1_2
              "
              style="
                margin-top: 0px;
                margin-bottom: 0px;
                width: 50%;
                width: calc(50% - ((4%) * 0.5));
                margin-right: 4%;
              "
            >
              <div class="fusion-text">
                <p style="font-size: 17px; font-weight: 500">
                  {{ participation.participation.supplierName }}
                </p>
              </div>
              <ul
                class="fusion-checklist fusion-checklist-3"
                style="font-size: 16px; line-height: 27.2px"
                *ngIf="participation.participation.attachments.length > 0"
              >
                <li class="fusion-li-item">
                  <span
                    style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                    class="icon-wrapper circle-no"
                    ><i
                      class="fusion-li-icon fa-images fas"
                      style="color: #333333"
                    ></i
                  ></span>
                  <div
                    class="fusion-li-item-content"
                    style="margin-left: 38.4px"
                  >
                    <p
                      style="
                        color: var(--ng-app-theme-yellow-color);
                        font-weight: 500;
                        font-size: 15px;
                      "
                    >
                      Scarica Allegati
                    </p>
                  </div>
                </li>
              </ul>
              <div
                style="
                  background-color: var(--ng-app-mid-grey-color);
                  padding: 10px;
                  max-height: 95px;
                  overflow: auto;
                  margin-bottom: 5px;
                "
                *ngIf="participation.participation.attachments.length > 0"
              >
                <div
                  *ngFor="
                    let attachment of participation.participation.attachments
                  "
                >
                  <div class="ng-attachment-box">
                    <p
                      style="
                        font-size: 14px;
                        font-weight: 500;
                        margin-bottom: 0px;
                        padding-left: 3px;
                        padding-bottom: 3px;
                      "
                    >
                      {{ getDocumentTypeDescription(attachment) }} &#8211;
                      {{ attachment.fileName }}
                    </p>
                    <i
                      (click)="openAttachment(attachment, $event)"
                      class="fas fa-download fa-sm"
                      style="
                        cursor: pointer;
                        color: var(--ng-app-theme-yellow-color);
                      "
                    ></i>
                  </div>
                </div>
              </div>
              <span
                (click)="
                  openAttachment(
                    participation.participation.metricCalculationDoc,
                    $event
                  )
                "
                class="fusion-popover popover-2"
              >
                <ul
                  class="fusion-checklist fusion-checklist-4"
                  style="font-size: 16px; line-height: 27.2px"
                >
                  <li class="fusion-li-item">
                    <span
                      style="
                        height: 27.2px;
                        width: 27.2px;
                        margin-right: 11.2px;
                      "
                      class="icon-wrapper circle-no"
                      ><i
                        class="fusion-li-icon fa-file-excel fas"
                        style="color: #333333"
                      ></i
                    ></span>
                    <div
                      class="fusion-li-item-content"
                      style="margin-left: 38.4px"
                    >
                      <p
                        style="
                          color: var(--ng-app-theme-yellow-color);
                          font-weight: 500;
                          font-size: 15px;
                        "
                      >
                        Scarica Computo
                      </p>
                    </div>
                  </li>
                </ul>
              </span>
            </div>
            <div
              class="
                fusion-layout-column
                fusion_builder_column
                fusion_builder_column_1_2
                fusion-builder-nested-column-12
                fusion-one-half
                fusion-column-last
                1_2
              "
              style="
                margin-top: 0px;
                margin-bottom: 0px;
                width: 50%;
                width: calc(50% - ((4%) * 0.5));
              "
            >
              <div
                class="fusion-column-wrapper fusion-column-wrapper-12"
                style="padding-left: 10px; background-position: left top"
              >
                <div class="fusion-text ng-estimate-box">
                  <p>Totale preventivo</p>
                  <p>
                    &euro;
                    {{
                      getEstimate(participation.participation.totalEstimate)
                        | currency: "EUR":"":"0.2-2":"it-IT"
                    }}
                  </p>
                </div>
                <div class="fusion-text ng-estimate-box">
                  <p>Preventivo scontato</p>
                  <p>
                    &euro;
                    {{
                      getEstimate(participation.participation.discountEstimate)
                        | currency: "EUR":"":"0.2-2":"it-IT"
                    }}
                  </p>
                </div>
                <div class="fusion-text ng-estimate-box">
                  <p>Preventivo finale</p>
                  <p>
                    &euro;
                    {{
                      getEstimate(participation.participation.dealEstimate)
                        | currency: "EUR":"":"0.2-2":"it-IT"
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="fusion-sep-clear"></div>
          <div
            class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 20px"
          ></div>
        </div>

        <div
          class="fusion-text"
          *ngIf="draftParticipationCountMessage"
          style="
            font-size: 15px;
            line-height: 1.4;
            font-weight: 400;
            color: #333333;
          "
        >
          ATTENZIONE: {{ draftParticipationCountMessage }} ancora pubblicato il
          preventivo. Stiamo facendo il possibile affinché l’operazione venga
          completata nel minor tempo possibile.
        </div>

        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 20px"
        ></div>
        <p (click)="goToQuestionsAndAnswers()" style="cursor: pointer">
          <a target="_self"><strong>Domande e risposte &gt;</strong></a>
        </p>
      </div>

      <!-- inizio partecipanti in stato di draft -->

      <div *ngIf="!canChangeTender">
        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 60px"
        ></div>
        <p style="margin-bottom: 0">
          <strong>CANDIDATURE SPONTANEE</strong>
        </p>

        <div
          class="fusion-text"
          style="font-size: 17px; font-style: italic"
          *ngIf="draftParticipations.length === 0"
        >
          In questa sezione verranno mostrati i candidati da accettare o
          rifiutare, non appena ce ne saranno.
        </div>
        <div
          class="fusion-text"
          style="font-size: 17px; font-style: italic"
          *ngIf="draftParticipations.length > 0"
        >
          Seleziona i partecipanti che desideri accettare o rifiutare nella
          gara.

          <div class="fusion-sep-clear"></div>
          <div
            class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 20px"
          ></div>

          <div *ngFor="let participation of draftParticipations">
            <div
              class="
                fusion-builder-row fusion-builder-row-inner fusion-row
                ng-selected-participation
              "
              style="
                background-color: var(--ng-app-light-grey-color);
                padding: 15px 15px 15px 15px;
                display: flex;
                justify-content: space-around;
                align-items: center;
                margin-bottom: 10px;
              "
            >
              <div
                class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_2
                  fusion-builder-nested-column-11
                  fusion-one-half
                  fusion-column-first
                  1_2
                "
                style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 50%;
                  width: calc(50% - ((4%) * 0.5));
                  margin-right: 4%;
                "
              >
                <div class="fusion-text">
                  <p
                    style="
                      font-size: 17px;
                      font-weight: 500;
                      margin-bottom: 0px !important;
                    "
                  >
                    {{ participation.supplierName }}
                  </p>
                </div>
              </div>
              <style type="text/css">
                .fusion-button.button-6 {
                  border-radius: 0px;
                }
              </style>
              <div>
                <a
                  (click)="
                    openApplicationsModal(true, participation.participationId)
                  "
                  style="margin-right: 10px"
                  class="
                    fusion-button
                    button-flat
                    fusion-button-default-size
                    button-default button-6
                    fusion-button-default-span fusion-button-default-type
                  "
                  target="_self"
                  ><span class="fusion-button-text">ACCETTA</span></a
                >
                <a
                  (click)="
                    openApplicationsModal(false, participation.participationId)
                  "
                  class="
                    fusion-button
                    button-flat
                    fusion-button-default-size
                    button-default button-6
                    fusion-button-default-span fusion-button-default-type
                  "
                  target="_self"
                  ><span class="fusion-button-text">RIFIUTA</span></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- fine partecipanti in stato di draft -->

      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none ng-space"
        style="margin-left: auto; margin-right: auto; margin-top: 25px"
      ></div>
      <div
        *ngIf="!showSaveMessage"
        [ngStyle]="{ visibility: error === 'no_error' ? 'hidden' : 'visible' }"
        class="ng-alert"
      >
        {{ error }}
      </div>
      <div *ngIf="showSaveMessage" class="ng-info">
        {{ saveMessage }}
      </div>
      <div class="ng-spinner">
        <img
          *ngIf="loading"
          src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"
        />
      </div>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 25px"
      ></div>
      <div
        class="fusion-builder-row fusion-builder-row-inner fusion-row"
        *ngIf="canChangeTender"
      >
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-34
            fusion-one-half
            fusion-column-first
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-34"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-top: 4px;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-aligncenter">
              <style type="text/css">
                .fusion-button.button-18 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="saveTender()"
                #saveButton
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default
                  fusion-button-default-span fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text">SALVA LA GARA</span></a
              >
            </div>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-35
            fusion-one-half
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-35"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-top: 4px;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-aligncenter">
              <style type="text/css">
                .fusion-button.button-19 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="tryPublishTender()"
                #publishButton
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default
                  fusion-button-default-span fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text">PUBBLICA LA GARA</span></a
              >
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="loadedTender.tenderStatus != 'DRAFT'">
        <p><strong>MIGLIORE OFFERTA</strong></p>
        <ul *ngIf="loadedTender.bestOffer !== null">
          <li >
            {{ loadedTender.bestOfferName }}:
            {{ loadedTender.bestOffer | currency: "EUR" }}
          </li>
        </ul>
        <p class="fusion-text" *ngIf="loadedTender.bestOffer === null">
          Non ci sono offerte
        </p>
      </div>
      <div
        class="fusion-button-wrapper fusion-aligncenter"
        *ngIf="canAskDiscount"
      >
        <style type="text/css">
          .fusion-button.button-6 {
            border-radius: 0px;
          }
        </style>
        <a
          (click)="openConfirmationModal()"
          class="
            fusion-button
            button-flat
            fusion-button-default-size
            button-default button-6
            fusion-button-default-span fusion-button-default-type
          "
          target="_self"
          ><span class="fusion-button-text">RICHIEDI SCONTO</span></a
        >
      </div>
      <div
        class="fusion-builder-row fusion-builder-row-inner fusion-row"
        *ngIf="
          loadedTender.tenderStatus === 'DEAL' && loadedTender.customer === null
        "
      >
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-34
            fusion-one-half
            fusion-column-first
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
            margin-right: 4%;
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-34"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-top: 4px;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-aligncenter">
              <style type="text/css">
                .fusion-button.button-18 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="confirmRefuseTender()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default
                  fusion-button-default-span fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text">RIFIUTA LA GARA</span></a
              >
            </div>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-35
            fusion-one-half
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((4%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-35"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-top: 4px;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-aligncenter">
              <style type="text/css">
                .fusion-button.button-19 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="confirmAcceptTender()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default
                  fusion-button-default-span fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text">ACCETTA IL VINCITORE</span></a
              >
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <app-modal #metricCalculationModal>
    <ng-template #header>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 100px"
      ></div>
      <div class="fusion-text">
        <h3 style="text-align: center">ATTENZIONE</h3>
      </div>
    </ng-template>
    <ng-template #body>
      <div class="fusion-text">
        <h5>
          Un computo metrico per questa gara è già stato caricato. Procedendo al
          caricamento il file già salvato verrà sovrascritto.
        </h5>
      </div>
    </ng-template>
    <ng-template #footer>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-21
            fusion-one-fourth
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((1%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-right: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <input
                style="display: none"
                type="file"
                (change)="uploadAttachment(null, $event)"
                #uploadMetricCalculationDocInputModal
              />
              <a
                (click)="uploadMetricCalculationDocInputModal.click()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left"
                  >CARICA COMPUTO</span
                ></a
              >
            </div>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-22
            fusion-one-fourth
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((1%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-left: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="metricCalculationModal.close()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left"
                  >ANNULLA</span
                ></a
              >
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </app-modal>

  <app-modal #confirmationModalDeal>
    <ng-template #header>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 100px"
      ></div>
      <div class="fusion-text">
        <h3 style="text-align: center">ATTENZIONE</h3>
      </div>
    </ng-template>
    <ng-template #body>
      <div class="fusion-text">
        <h5>{{ confirmationModalMsg }}</h5>
      </div>
    </ng-template>
    <ng-template #footer>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-21
            fusion-one-fourth
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 100%;
            width: calc(100% - ((1%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-right: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="confirmationModalSubmit()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left">{{
                  confirmationModalSubmitMsg
                }}</span></a
              >
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </app-modal>

  <app-modal #confirmationModal>
    <ng-template #header>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 100px"
      ></div>
      <div class="fusion-text">
        <h3 style="text-align: center">ATTENZIONE</h3>
      </div>
    </ng-template>
    <ng-template #body>
      <div class="fusion-text">
        <h5>{{ confirmationModalMsg }}</h5>
      </div>
    </ng-template>
    <ng-template #footer>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-21
            fusion-one-fourth
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((1%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-right: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="confirmationModalSubmit()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left">{{
                  confirmationModalSubmitMsg
                }}</span></a
              >
            </div>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-22
            fusion-one-fourth
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((1%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-left: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="confirmationModal.close()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left"
                  >ANNULLA</span
                ></a
              >
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </app-modal>

  <app-modal #applicationsModal>
    <ng-template #header>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 100px"
      ></div>
      <div class="fusion-text">
        <h3 style="text-align: center">ATTENZIONE</h3>
      </div>
    </ng-template>
    <ng-template #body>
      <div class="fusion-text">
        <h5>{{ applicationsModalMsg }}</h5>
      </div>
    </ng-template>
    <ng-template #footer>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-21
            fusion-one-fourth
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((1%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-right: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="applicationsModalSubmit()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left">{{
                  applicationsModalSubmitMsg
                }}</span></a
              >
            </div>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-22
            fusion-one-fourth
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((1%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-left: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="confirmationModal.close()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left"
                  >ANNULLA</span
                ></a
              >
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </app-modal>

  <app-modal #sharingEmailRequestModal>
    <ng-template #header>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 100px"
      ></div>
      <div class="fusion-text">
        <h3 style="text-align: center">CONDIVIDI</h3>
      </div>
    </ng-template>
    <ng-template #body>
      <div class="fusion-text">
        <form [formGroup]="sharingForm" id="sharing-appform">
          <input
            type="email"
            formControlName="sharingEmail"
            required
            email
            placeholder="Inserire l'email di un utente Skimming"
          />
          <div
            [ngStyle]="{
              visibility:
                sharingForm.get('sharingEmail').valid ||
                sharingForm.get('sharingEmail').pristine
                  ? 'hidden'
                  : 'visible'
            }"
            class="ng-alert"
          >
            Inserire un'email valida.
          </div>
        </form>
        <div
          *ngIf="!showSaveMessage"
          [ngStyle]="{
            visibility: sharingError === 'no_error' ? 'hidden' : 'visible'
          }"
          class="ng-alert"
        >
          {{ sharingError }}
        </div>
        <div class="ng-spinner">
          <img
            *ngIf="sharingLoading"
            src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"
          />
        </div>
      </div>
    </ng-template>
    <ng-template #footer>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-21
            fusion-one-fourth
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((1%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-right: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="shareTender()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left"
                  >INVIA INVITO</span
                ></a
              >
            </div>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-22
            fusion-one-fourth
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((1%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-left: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="sharingEmailRequestModal.close()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left"
                  >ANNULLA</span
                ></a
              >
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </app-modal>
  <app-modal #sharingEmailOkModal>
    <ng-template #header>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 100px"
      ></div>
      <div class="fusion-text">
        <h3 style="text-align: center">COMPLIMENTI</h3>
      </div>
    </ng-template>
    <ng-template #body>
      <div class="fusion-text">
        <h5>
          L'email per la condivisione della gara è stata inviata correttamente.
        </h5>
      </div>
    </ng-template>
    <ng-template #footer>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div style="text-align: center">
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-right: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="sharingEmailOkModal.close()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left"
                  >OK</span
                ></a
              >
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </app-modal>
  <app-modal #searchDesignerModal>
    <ng-template #header>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 100px"
      ></div>
      <div class="fusion-text">
        <h3 style="text-align: center">CERCA PROGETTISTA</h3>
      </div>
    </ng-template>
    <ng-template #body>
      <div class="fusion-text">
        <div>
          <div style="display: flex; width: 100%">
            <input
              type="text"
              [(ngModel)]="designerFilter"
              [ngModelOptions]="{ standalone: true }"
              style="margin: 0 !important"
            />
            <span
              (click)="searchDesigners()"
              style="
                cursor: pointer;
                border: 0px !important;
                border-radius: 0px !important;
                padding: 8px 15px !important;
                background-color: #fbfbfb;
              "
              class="icon-wrapper circle-no"
              ><i
                class="fusion-li-icon fa-search fas"
                style="color: var(--ng-app-theme-yellow-color)"
              ></i
            ></span>
          </div>
          <style type="text/css">
            .designerLi:hover {
              background-color: var(--ng-app-mid-grey-color);
              cursor: pointer;
            }
          </style>
          <div
            *ngIf="showDesignerSelect"
            style="max-height: 150px; overflow: auto"
          >
            <ul
              class="fusion-checklist fusion-checklist-1"
              style="
                font-size: 16px;
                line-height: 27.2px;
                background-color: #fbfbfb;
                padding: 2%;
                margin-top: 0;
                border: 1px solid var(--ng-app-mid-grey-color) !important;
              "
            >
              <li
                class="fusion-li-item designerLi"
                (click)="selectDesigner(designer)"
              >
                <div class="desinger-container">
                  <strong class="designer-item-left">Nome progettista</strong>
                  <strong class="designer-item-right">Distanza in Km</strong>
                </div>
              </li>
              <li
                *ngFor="let designer of designers"
                class="fusion-li-item designerLi"
                (click)="selectDesigner(designer)"
              >
                <div class="desinger-container">
                  <span class="designer-item-left">{{ designer.name }}</span>
                  <span class="designer-item-right">{{
                    getRoundedDistance(designer.distance)
                  }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div
          [ngStyle]="{
            visibility: designerError === 'no_error' ? 'hidden' : 'visible'
          }"
          class="ng-alert"
        >
          {{ designerError }}
        </div>
        <div class="ng-spinner">
          <img
            *ngIf="designerLoading"
            src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"
          />
        </div>
      </div>
    </ng-template>
    <ng-template #footer>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-21
            fusion-one-fourth
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((1%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-right: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="inviteDesigner()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left"
                  >INVIA INVITO</span
                ></a
              >
            </div>
          </div>
        </div>
        <div
          class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_2
            fusion-builder-nested-column-22
            fusion-one-fourth
            fusion-column-last
            1_2
          "
          style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 50%;
            width: calc(50% - ((1%) * 0.5));
          "
        >
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-left: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="closeDesignerSelection()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left"
                  >ANNULLA</span
                ></a
              >
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </app-modal>
  <app-modal #searchDesignerOkModal>
    <ng-template #header>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 100px"
      ></div>
      <div class="fusion-text">
        <h3 style="text-align: center">COMPLIMENTI</h3>
      </div>
    </ng-template>
    <ng-template #body>
      <div class="fusion-text">
        <h5>E' stata mandata un'email al progettista che hai scelto.</h5>
      </div>
    </ng-template>
    <ng-template #footer>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div style="text-align: center">
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-right: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="searchDesignerOkModal.close()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left"
                  >OK</span
                ></a
              >
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </app-modal>
  <app-modal #searchDesignerKoModal>
    <ng-template #header>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 100px"
      ></div>
      <div class="fusion-text">
        <h3 style="text-align: center">ATTENZIONE</h3>
      </div>
    </ng-template>
    <ng-template #body>
      <div class="fusion-text">
        <h5>
          Per poter selezionare un progettista &egrave; necessario inserire
          l'indirizzo completo e salvare il preventivo.
        </h5>
      </div>
    </ng-template>
    <ng-template #footer>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div style="text-align: center">
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-right: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="searchDesignerKoModal.close()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left"
                  >OK</span
                ></a
              >
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </app-modal>
  <app-modal #toManyAttachmentsWarningModal>
    <ng-template #header>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 100px"
      ></div>
      <div class="fusion-text">
        <h3 style="text-align: center">ATTENZIONE</h3>
      </div>
    </ng-template>
    <ng-template #body>
      <div class="fusion-text">
        <h5>
          Per gare private non è possibile allegare più di
          {{ privateTenderMaxAttachmentNumber }} file.
        </h5>
      </div>
    </ng-template>
    <ng-template #footer>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div style="text-align: center">
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-right: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="toManyAttachmentsWarningModal.close()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left"
                  >CHIUDI</span
                ></a
              >
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </app-modal>
  <app-modal #infoUpgrateTenderModal>
    <ng-template #header>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 100px"
      ></div>
      <div class="fusion-text">
        <h3 style="text-align: center">
          AGGIORNA LA TUA GARA A PROFESSIONISTI
        </h3>
      </div>
    </ng-template>
    <ng-template #body>
      <div class="fusion-text">
        <h5>
          Aggiornando la tua gara a professionisti potrai ottenere i seguenti
          vantaggi:
        </h5>
        <ul>
          <li>
            <h5>
              possibilit&agrave; di aggiungere un numero illimitato di allegati
            </h5>
          </li>
          <li>
            <h5>
              possibilit&agrave; di scegliere se mostrare la migliore offerta ai
              futuri partecipanti
            </h5>
          </li>
          <li>
            <h5>
              possibilit&agrave; di inserire un computo metrico invece di dover
              inserire manualmente i dettagli della tua gara
            </h5>
          </li>
        </ul>
      </div>
    </ng-template>
    <ng-template #footer>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div style="text-align: center">
          <div
            class="fusion-column-wrapper fusion-column-wrapper-22"
            style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              margin-right: 4%;
            "
            data-bg-url=""
          >
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-10 {
                  border-radius: 0px;
                }
              </style>
              <a
                (click)="infoUpgrateTenderModal.close()"
                class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-10
                  fusion-button-span-yes fusion-button-default-type
                "
                target="_self"
                ><span class="fusion-button-text fusion-button-text-left"
                  >CHIUDI</span
                ></a
              >
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </app-modal>
</div>
